<template>
  <div class="customerDetails">
    <header v-show="!isDeviceModalShow">
      <h1>{{ title }}</h1>
      <a-space>
        <a-button @click="goBack()" style="color: rgb(33, 141, 235)" icon="rollback" >
          <span style="color: #000">{{ $t('buttons.goBack' )}}</span>
        </a-button>
        <a-button :loading="isLoading" type="primary" @click="handleSava">{{ $t('buttons.save' )}}</a-button>
      </a-space>
    </header>
    <section class="userInfo" v-show="!isDeviceModalShow">
      <div class="infoList">
        <div class="up">
          <div class="input-wrapper">
            <label>{{ $t('customer.company') }}：</label>
            <div class="inputSelect">
              <div class="ant-form-item-control" :class="{ 'has-error': errorOptions.company }" style="width: 500px">
                <span class="ant-form-item-children">
                  <input v-model="form.company" @blur="handleCBlur" @keyup.enter="handleSearchCompany" :placeholder="$t('messages.company_empty')" type="text" class="ant-input" style="width: 500px;">
                </span>
                <div class="ant-form-explain" v-show="errorOptions.company">{{ $t('messages.company_empty') }}</div>
              </div>
              <ul v-show="isCompanyListShow" class="companyList">
                <li @mouseenter="handleMouseenter" @mouseleave="handleMouseleave" @mousedown="handleClick(item, i)" v-for="(item, i) in companyList" :key="i" :class="{ selected: i === selectedCompanyIndex }">{{ item.company }}</li>
                <a-spin class="spin" v-show="isCompanyLoading"></a-spin>
              </ul>
            </div>
          </div>
          <div class="input-wrapper">
            <label>{{ $t('customer.address') }}：</label>
            <div class="ant-form-item-control" :class="{ 'has-error': errorOptions.address }" style="width: 500px">
              <span class="ant-form-item-children">
                <input v-model="form.address" @blur="validate('address')" :placeholder="$t('messages.address_empty')" type="text" class="ant-input" style="width: 500px;">
              </span>
              <div class="ant-form-explain" v-show="errorOptions.address">{{ $t('messages.address_empty') }}</div>
            </div>
          </div>
          <div style="display: flex; margin: 10px 0" v-if="lKey === 'addTitle' || authorities.find(a => a.code === 'customer:contact:visible')">
            <label style="width: 100px; margin-right: 10px">{{ $t('customer.mobile') }}：</label>
            <div class="ant-form-item-control" style="width: 500px; margin-top: -5px">
              <span class="ant-form-item-children">
                <input v-model="form.mobile" :placeholder="$t('placeholder.mobile')" type="text" class="ant-input" style="width: 500px;">
              </span>
            </div>
          </div>
          <div style="display: flex; margin: 10px 0" v-if="lKey === 'addTitle' || authorities.find(a => a.code === 'customer:contact:visible')">
            <label style="width: 100px; margin-right: 10px">{{ $t('customer.contactPerson') }}：</label>
            <div class="ant-form-item-control" style="width: 500px; margin-top: -5px">
              <span class="ant-form-item-children">
                <input v-model="form.contactPerson" :placeholder="$t('placeholder.contactPerson')" type="text" class="ant-input" style="width: 500px;">
              </span>
            </div>
          </div>
          <div class="input-wrapper" v-if="!authorities.find(a => a.code === 'customer:contact:visible')">
            <label>{{ $t('customer.area') }}：</label>
            <div class="inputSelect">
              <div class="ant-form-item-control" :class="{ 'has-error': errorOptions.area }" style="width: 500px">
                <span class="ant-form-item-children">
                  <input v-model="form.area" @focus="isAreaListShow = true" @blur="handleAreaBlur" :placeholder="$t('messages.area_empty')" type="text" class="ant-input" style="width: 500px;" @keyup.enter="searchAreas">
                </span>
                <div class="ant-form-explain" v-show="errorOptions.area">{{ $t('messages.area_empty') }}</div>
              </div>
              <ul v-show="isAreaListShow && areas.length > 0" class="companyList">
                <li @mouseenter="handleMouseenter" @mouseleave="handleMouseleave" @mousedown="selectArea($event, i)" v-for="(item, i) in areas" :key="item.name" :class="{ selected: item.name === form.area }">{{ item.name }}</li>
              </ul>
            </div>
          </div>
        </div>
        <div class="down">
          <div class="input-wrapper">
            <label class="disapear">{{ $t('customer.country') }}：</label>
            <div class="inputSelect">
              <div class="ant-form-item-control" style="width: 500px">
                <span class="ant-form-item-children">
                  <input v-model="form.country" @focus="isCountryListShow = true" @blur="handleCountryBlur" :placeholder="$t('customer.country_empty')" type="text" class="ant-input" style="width: 500px;" @keyup.enter="searchCountries">
                </span>
              </div>
              <ul v-show="isCountryListShow && countries.length > 0" class="companyList">
                <li @mouseenter="handleMouseenter" @mouseleave="handleMouseleave" @mousedown="selectCountry($event, i)" v-for="(item, i) in countries" :key="item.name" :class="{ selected: item.name === form.country }">{{ item.name }}</li>
              </ul>
            </div>
          </div>
          <div class="input-wrapper">
            <label>{{ $t('customer.province') }}：</label>
            <div class="inputSelect">
              <div class="ant-form-item-control" :class="{ 'has-error': errorOptions.province }" style="width: 500px">
                <span class="ant-form-item-children">
                  <input v-model="form.province" @focus="isProvinceListShow = true" @blur="handleProvinceBlur" :placeholder="$t('messages.province_empty')" type="text" class="ant-input" style="width: 500px;" @keyup.enter="searchProvinces">
                </span>
                <div class="ant-form-explain" v-show="errorOptions.province">{{ $t('messages.province_empty') }}</div>
              </div>
              <ul v-show="isProvinceListShow && provinces.length > 0" class="companyList">
                <li @mouseenter="handleMouseenter" @mouseleave="handleMouseleave" @mousedown="selectProvince($event, i)" v-for="(item, i) in provinces" :key="item.name" :class="{ selected: item.name === form.province }">{{ item.name }}</li>
              </ul>
            </div>
          </div>
          <div class="input-wrapper">
            <label>{{ $t('customer.city') }}：</label>
            <div class="inputSelect">
              <div class="ant-form-item-control" :class="{ 'has-error': errorOptions.city }" style="width: 500px">
                <span class="ant-form-item-children">
                  <input v-model="form.city" @focus="isCityListShow = true" @blur="handleCityBlur" :placeholder="$t('messages.city_empty')" type="text" class="ant-input" style="width: 500px;" @keyup.enter="searchCityss">
                </span>
                <div class="ant-form-explain" v-show="errorOptions.city">{{ $t('messages.city_empty') }}</div>
              </div>
              <ul v-show="isCityListShow && citys.length > 0" class="companyList">
                <li @mouseenter="handleMouseenter" @mouseleave="handleMouseleave" @mousedown="selectCity($event, i)" v-for="(item, i) in citys" :key="item.name" :class="{ selected: item.name === form.city }">{{ item.name }}</li>
              </ul>
            </div>
          </div>
          <div class="input-wrapper" v-if="authorities.find(a => a.code === 'customer:contact:visible')">
            <label>{{ $t('customer.area') }}：</label>
            <div class="inputSelect">
              <div class="ant-form-item-control" :class="{ 'has-error': errorOptions.area }" style="width: 500px">
                <span class="ant-form-item-children">
                  <input v-model="form.area" @focus="isAreaListShow = true" @blur="handleAreaBlur" :placeholder="$t('messages.area_empty')" type="text" class="ant-input" style="width: 500px;" @keyup.enter="searchAreas">
                </span>
                <div class="ant-form-explain" v-show="errorOptions.area">{{ $t('messages.area_empty') }}</div>
              </div>
              <ul v-show="isAreaListShow && areas.length > 0" class="companyList">
                <li @mouseenter="handleMouseenter" @mouseleave="handleMouseleave" @mousedown="selectArea($event, i)" v-for="(item, i) in areas" :key="item.name" :class="{ selected: item.name === form.area }">{{ item.name }}</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
    <div class="content" v-show="!isDeviceModalShow">
      <a-card
        :border="false"
        :tab-list="tabList"
        :active-tab-key="tabKey"
        :scroll="{ y: 1000 }"
        @tabChange="key => onTabChange(key)"
      >
        <div v-show="tabKey === 'device'">
          <a-button @click="showDeviceModal" type="primary" style="position: absolute; top: 12px; right: 20px;">{{ $t('customer.addDevice') }}</a-button>
          <a-modal class="device" v-model="deviceModalVisible" :title="$t('customer.addDevice' )" :width="1600" @ok="selectUsers" :footer="null">
            <a-button style="margin-bottom: 10px" type="primary" @click="showAddDeviceModal">{{ $t('buttons.add') }}</a-button>
            <a-table
              :loading="isDeviceLoading"
              :columns="deviceInnerColumns"
              :data-source="devicesList"
              :pagination="devicePagination"
              :row-key="record => record.id"
              @change="handleDeviceTableChange"
            >
              <template v-slot:operation="_, record">
                <a-popconfirm
                  :title="$t('messages.cta')"
                  :ok-text="$t('common.okText')"
                  :cancel-text="$t('common.cancelText')"
                  @confirm="changeDeviceCustomer(record)"
                >
                  <a :disabled="record.customerId == id" href="javascript:;">{{ $t('buttons.bind') }}</a>
                </a-popconfirm>
              </template>
              <template v-slot:icon="text">
                <a-icon :type="text" style="font-size: 20px" />
              </template>
              <template v-slot:enabled="text">
                {{ text ? $t('common.yes') : $t('common.no') }}
              </template>
            </a-table>
          </a-modal>
          <a-table
            :loading="outerTableLoading"
            :columns="deviceColumns"
            :data-source="selectedDeviceList"
            :pagination="outerDevicePagination"
            :row-key="record => record.id"
            @change="handleDeviceOuterTableChange"
          >
            <template v-slot:updatedAt="text, record">
              {{ moment(record.updatedAt).format('YYYY-MM-DD HH:mm') }}
            </template>
            <template v-slot:createdAt="text, record">
              {{ moment(record.createdAt).format('YYYY-MM-DD HH:mm') }}
            </template>
            <template v-slot:operation="_, record">
              <a-button
                type="link"
                style="padding-left: 0"
                @click="gotoDevice(record)"
              >{{ $t('buttons.edit') }}</a-button>
              <a-popconfirm
                :title="$t('messages.ctrd')"
                :ok-text="$t('common.okText')"
                :cancel-text="$t('common.cancelText')"
                @confirm="removeDevice(record)"
              >
                <a href="javascript:;">{{ $t('buttons.delete') }}</a>
              </a-popconfirm>
            </template>
          </a-table>
        </div>
        <div v-show="tabKey === 'system'">
          <a-form-model layout="inline" style="margin-bottom: 10px">
            <!-- <a-form-model-item label="修改方式">
              <a-select v-model="params.request" style="width: 70px">
                <a-select-option value="">全部</a-select-option>
                <a-select-option value="POST">新增</a-select-option>
                <a-select-option value="PUT">更新</a-select-option>
              </a-select>
            </a-form-model-item> -->
            <a-form-model-item :label="$t('common.startTime')">
              <a-date-picker @change="changeStartTime" />
            </a-form-model-item>
            <a-form-model-item :label="$t('common.endTime')">
              <a-date-picker @change="changeEndTime" />
            </a-form-model-item>
            <a-button type="primary" style="float: right" @click="getS">{{ $t('buttons.search') }}</a-button>
          </a-form-model>
          <el-table
            :data="systemLogList"
            style="width: 100%"
            :header-cell-style="{ backgroundColor: '#fafafa' }"
            v-loading="isSystemLogLoading"
            @expand-change="handleExpand"
          >
            <el-table-column type="expand">
              <template slot-scope="props">
                <div style="padding: 0 50px">
                  <a-spin v-show="!props.row.description"></a-spin>
                  <div v-show="props.row.description" class="system_log_description">
                    <h3 style="margin-bottom: 15px">{{ $t('common.details') }}</h3>
                    <a-row style="margin-bottom: 15px">
                      <a-col :span="7">
                        <p v-if="Array.isArray(props.row.description.company)">
                          {{ $t('customer.company') }}: 
                          <span style="color: red">{{ props.row.description.company[0] }}</span>
                          <span>→</span>
                          <span style="color: green">{{ props.row.description.company[1] }}</span>
                        </p>
                        <p v-else>{{ $t('customer.company') }}: {{ props.row.description.company }}</p>
                        <p v-if="Array.isArray(props.row.description.city)">
                          {{ $t('customer.city') }}: 
                          <span style="color: red">{{ props.row.description.city[0] }}</span>
                          <span>→</span>
                          <span style="color: green">{{ props.row.description.city[1] }}</span>
                        </p>
                        <p v-else>{{ $t('customer.city') }}: {{ props.row.description.city }}</p>
                        <p v-if="Array.isArray(props.row.description.mobile)">
                          {{ $t('customer.mobile') }}: 
                          <span style="color: red">{{ props.row.description.mobile[0] }}</span>
                          <span>→</span>
                          <span style="color: green">{{ props.row.description.mobile[1] }}</span>
                        </p>
                        <p v-else>{{ $t('customer.mobile') }}: {{ props.row.description.mobile }}</p>
                      </a-col>
                      <a-col :span="10">
                        <p v-if="Array.isArray(props.row.description.address)">
                          {{ $t('customer.address') }}: 
                          <span style="color: red">{{ props.row.description.address[0] }}</span>
                          <span>→</span>
                          <span style="color: green">{{ props.row.description.address[1] }}</span>
                        </p>
                        <p v-else>{{ $t('customer.address') }}: {{ props.row.description.address }}</p>
                        <p v-if="Array.isArray(props.row.description.area)">
                          {{ $t('customer.area') }}: 
                          <span style="color: red">{{ props.row.description.area[0] }}</span>
                          <span>→</span>
                          <span style="color: green">{{ props.row.description.area[1] }}</span>
                        </p>
                        <p v-else>{{ $t('customer.area') }}: {{ props.row.description.area }}</p>
                      </a-col>
                      <a-col :span="7">
                        <p v-if="Array.isArray(props.row.description.province)">
                          {{ $t('customer.province') }}: 
                          <span style="color: red">{{ props.row.description.province[0] }}</span>
                          <span>→</span>
                          <span style="color: green">{{ props.row.description.province[1] }}</span>
                        </p>
                        <p v-else>{{ $t('customer.province') }}: {{ props.row.description.province }}</p>
                        <p v-if="Array.isArray(props.row.description.contactPerson)">
                          {{ $t('customer.contactPerson') }}: 
                          <span style="color: red">{{ props.row.description.contactPerson[0] }}</span>
                          <span>→</span>
                          <span style="color: green">{{ props.row.description.contactPerson[1] }}</span>
                        </p>
                        <p v-else>{{ $t('customer.contactPerson') }}: {{ props.row.description.contactPerson }}</p>
                      </a-col>
                    </a-row>
                    <a-row>
                      <a-col>
                        <h4>{{ $t('common.user') }}: </h4>
                        <p v-for="u in props.row.description.users" :key="u.id" style="position: relative;" :style="{ marginLeft: u.add || u.minus ? '-30px' : '0', color: u.add ? 'green' : u.minus ? 'red' : '' }">
                          <span v-if="u.add" style="color: green; margin: 0; padding: 0"> + </span>
                          <span v-if="u.minus" style="color: red; margin: 0; padding: 0; margin-right: 5px"> - </span>
                          <span>{{ $t('user.columns.name') }}: {{ u.realName }}</span>
                          <span>{{ $t('user.columns.mobile') }}: {{ u.username }}</span>
                          <span>{{ $t('user.columns.organization') }}: {{ u.organization }}</span>
                          <template v-if="props.row.description.showEnable">
                            <span v-if="Array.isArray(u.maintainSmsEnabled)">
                              {{ $t('customer.maintainSmsEnabled') }}: 
                              <span style="color: red">{{ u.maintainSmsEnabled[0] ? $t('common.open') : $t('common.close') }}</span>
                              <span>→</span>
                              <span style="color: green">{{ u.maintainSmsEnabled[1] ? $t('common.open') : $t('common.close') }}</span>
                            </span>
                            <span v-else>{{ $t('customer.maintainSmsEnabled') }}: {{ u.maintainSmsEnabled ? $t('common.open') : $t('common.close') }}</span>
                            <span v-if="Array.isArray(u.inspectionSmsEnabled)">
                              {{ $t('customer.inspectionSmsEnabled') }}: 
                              <span style="color: red">{{ u.inspectionSmsEnabled[0] ? $t('common.open') : $t('common.close') }}</span>
                              <span>→</span>
                              <span style="color: green">{{ u.inspectionSmsEnabled[1] ? $t('common.open') : $t('common.close') }}</span>
                            </span>
                            <span v-else>{{ $t('customer.inspectionSmsEnabled') }}: {{ u.inspectionSmsEnabled ? $t('common.open') : $t('common.close') }}</span>
                            <span v-if="Array.isArray(u.errorSmsEnabled)">
                              {{ $t('customer.errorSmsEnabled') }}: 
                              <span style="color: red">{{ u.errorSmsEnabled[0] ? $t('common.open') : $t('common.close') }}</span>
                              <span>→</span>
                              <span style="color: green">{{ u.errorSmsEnabled[1] ? $t('common.open') : $t('common.close') }}</span>
                            </span>
                            <span v-else>{{ $t('customer.errorSmsEnabled') }}: {{ u.errorSmsEnabled ? $t('common.open') : $t('common.close') }}</span>
                          </template>
                        </p>
                      </a-col>
                    </a-row>
                    <a-row>
                      <a-col>
                        <h4>{{ $t('common.salesMen') }}: </h4>
                        <p v-for="u in props.row.description.salesmen" :key="u.id" style="position: relative;" :style="{ marginLeft: u.add || u.minus ? '-30px' : '0', color: u.add ? 'green' : u.minus ? 'red' : '' }">
                          <span v-if="u.add" style="color: green; margin: 0; padding: 0"> + </span>
                          <span v-if="u.minus" style="color: red; margin: 0; padding: 0; margin-right: 5px"> - </span>
                          <span>{{ $t('user.columns.name') }}: {{ u.realName }}</span>
                          <span>{{ $t('user.columns.mobile') }}: {{ u.username }}</span>
                          <span>{{ $t('user.columns.organization') }}: {{ u.organization }}</span>
                          <template v-if="props.row.description.showEnable">
                            <span v-if="Array.isArray(u.maintainSmsEnabled)">
                              {{ $t('customer.maintainSmsEnabled') }}: 
                              <span style="color: red">{{ u.maintainSmsEnabled[0] ? $t('common.open') : $t('common.close') }}</span>
                              <span>→</span>
                              <span style="color: green">{{ u.maintainSmsEnabled[1] ? $t('common.open') : $t('common.close') }}</span>
                            </span>
                            <span v-else>{{ $t('customer.maintainSmsEnabled') }}: {{ u.maintainSmsEnabled ? $t('common.open') : $t('common.close') }}</span>
                            <span v-if="Array.isArray(u.inspectionSmsEnabled)">
                              {{ $t('customer.inspectionSmsEnabled') }}: 
                              <span style="color: red">{{ u.inspectionSmsEnabled[0] ? $t('common.open') : $t('common.close') }}</span>
                              <span>→</span>
                              <span style="color: green">{{ u.inspectionSmsEnabled[1] ? $t('common.open') : $t('common.close') }}</span>
                            </span>
                            <span v-else>{{ $t('customer.inspectionSmsEnabled') }}: {{ u.inspectionSmsEnabled ? $t('common.open') : $t('common.close') }}</span>
                            <span v-if="Array.isArray(u.errorSmsEnabled)">
                              {{ $t('customer.errorSmsEnabled') }}: 
                              <span style="color: red">{{ u.errorSmsEnabled[0] ? $t('common.open') : $t('common.close') }}</span>
                              <span>→</span>
                              <span style="color: green">{{ u.errorSmsEnabled[1] ? $t('common.open') : $t('common.close') }}</span>
                            </span>
                            <span v-else>{{ $t('customer.errorSmsEnabled') }}: {{ u.errorSmsEnabled ? $t('common.open') : $t('common.close') }}</span>
                          </template>
                        </p>
                      </a-col>
                    </a-row>
                    <a-row>
                      <a-col>
                        <h4>{{ $t('common.serviceMen') }}: </h4>
                        <p v-for="u in props.row.description.serviceMans" :key="u.id" style="position: relative;" :style="{ marginLeft: u.add || u.minus ? '-30px' : '0', color: u.add ? 'green' : u.minus ? 'red' : '' }">
                          <span v-if="u.add" style="color: green; margin: 0; padding: 0"> + </span>
                          <span v-if="u.minus" style="color: red; margin: 0; padding: 0; margin-right: 5px"> - </span>
                          <span>{{ $t('user.columns.name') }}: {{ u.realName }}</span>
                          <span>{{ $t('user.columns.mobile') }}: {{ u.username }}</span>
                          <span>{{ $t('user.columns.organization') }}: {{ u.organization }}</span>
                          <template v-if="props.row.description.showEnable">
                            <span v-if="Array.isArray(u.maintainSmsEnabled)">
                              {{ $t('customer.maintainSmsEnabled') }}: 
                              <span style="color: red">{{ u.maintainSmsEnabled[0] ? $t('common.open') : $t('common.close') }}</span>
                              <span>→</span>
                              <span style="color: green">{{ u.maintainSmsEnabled[1] ? $t('common.open') : $t('common.close') }}</span>
                            </span>
                            <span v-else>{{ $t('customer.maintainSmsEnabled') }}: {{ u.maintainSmsEnabled ? $t('common.open') : $t('common.close') }}</span>
                            <span v-if="Array.isArray(u.inspectionSmsEnabled)">
                              {{ $t('customer.inspectionSmsEnabled') }}: 
                              <span style="color: red">{{ u.inspectionSmsEnabled[0] ? $t('common.open') : $t('common.close') }}</span>
                              <span>→</span>
                              <span style="color: green">{{ u.inspectionSmsEnabled[1] ? $t('common.open') : $t('common.close') }}</span>
                            </span>
                            <span v-else>{{ $t('customer.inspectionSmsEnabled') }}: {{ u.inspectionSmsEnabled ? $t('common.open') : $t('common.close') }}</span>
                            <span v-if="Array.isArray(u.errorSmsEnabled)">
                              {{ $t('customer.errorSmsEnabled') }}: 
                              <span style="color: red">{{ u.errorSmsEnabled[0] ? $t('common.open') : $t('common.close') }}</span>
                              <span>→</span>
                              <span style="color: green">{{ u.errorSmsEnabled[1] ? $t('common.open') : $t('common.close') }}</span>
                            </span>
                            <span v-else>{{ $t('customer.errorSmsEnabled') }}: {{ u.errorSmsEnabled ? $t('common.open') : $t('common.close') }}</span>
                          </template>
                        </p>
                      </a-col>
                    </a-row>
                    <a-row>
                      <a-col>
                        <h4>{{ $t('common.followers') }}: </h4>
                        <p v-for="u in props.row.description.followers" :key="u.id" style="position: relative;" :style="{ marginLeft: u.add || u.minus ? '-30px' : '0', color: u.add ? 'green' : u.minus ? 'red' : '' }">
                          <span v-if="u.add" style="color: green; margin: 0; padding: 0"> + </span>
                          <span v-if="u.minus" style="color: red; margin: 0; padding: 0; margin-right: 5px"> - </span>
                          <span>{{ $t('user.columns.name') }}: {{ u.realName }}</span>
                          <span>{{ $t('user.columns.mobile') }}: {{ u.username }}</span>
                          <span>{{ $t('user.columns.organization') }}: {{ u.organization }}</span>
                          <template v-if="props.row.description.showEnable">
                            <span v-if="Array.isArray(u.maintainSmsEnabled)">
                              {{ $t('customer.maintainSmsEnabled') }}: 
                              <span style="color: red">{{ u.maintainSmsEnabled[0] ? $t('common.open') : $t('common.close') }}</span>
                              <span>→</span>
                              <span style="color: green">{{ u.maintainSmsEnabled[1] ? $t('common.open') : $t('common.close') }}</span>
                            </span>
                            <span v-else>{{ $t('customer.maintainSmsEnabled') }}: {{ u.maintainSmsEnabled ? $t('common.open') : $t('common.close') }}</span>
                            <span v-if="Array.isArray(u.inspectionSmsEnabled)">
                              {{ $t('customer.inspectionSmsEnabled') }}: 
                              <span style="color: red">{{ u.inspectionSmsEnabled[0] ? $t('common.open') : $t('common.close') }}</span>
                              <span>→</span>
                              <span style="color: green">{{ u.inspectionSmsEnabled[1] ? $t('common.open') : $t('common.close') }}</span>
                            </span>
                            <span v-else>{{ $t('customer.inspectionSmsEnabled') }}: {{ u.inspectionSmsEnabled ? $t('common.open') : $t('common.close') }}</span>
                            <span v-if="Array.isArray(u.errorSmsEnabled)">
                              {{ $t('customer.errorSmsEnabled') }}: 
                              <span style="color: red">{{ u.errorSmsEnabled[0] ? $t('common.open') : $t('common.close') }}</span>
                              <span>→</span>
                              <span style="color: green">{{ u.errorSmsEnabled[1] ? $t('common.open') : $t('common.close') }}</span>
                            </span>
                            <span v-else>{{ $t('customer.errorSmsEnabled') }}: {{ u.errorSmsEnabled ? $t('common.open') : $t('common.close') }}</span>
                          </template>
                        </p>
                      </a-col>
                    </a-row>
                    <a-row>
                      <a-col>
                        <h4>{{ $t('common.authUsers') }}: </h4>
                        <p v-for="u in props.row.description.visitUsers" :key="u.id" style="position: relative;" :style="{ marginLeft: u.add || u.minus ? '-30px' : '0', color: u.add ? 'green' : u.minus ? 'red' : '' }">
                          <span v-if="u.add" style="color: green; margin: 0; padding: 0"> + </span>
                          <span v-if="u.minus" style="color: red; margin: 0; padding: 0; margin-right: 5px"> - </span>
                          <span>{{ $t('user.columns.name') }}: {{ u.realName }}</span>
                          <span>{{ $t('user.columns.mobile') }}: {{ u.username }}</span>
                          <span>{{ $t('user.columns.organization') }}: {{ u.organization }}</span>
                        </p>
                      </a-col>
                    </a-row>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              :label="$t('common.operationUser')"
              prop="user.realName">
            </el-table-column>
            <el-table-column
              :label="$t('common.mobile')"
              prop="user.username">
            </el-table-column>
            <el-table-column
              :label="$t('common.organization')"
              prop="user.organizationName">
            </el-table-column>
            <el-table-column
              :label="$t('common.request')"
              prop="request">
            </el-table-column>
            <el-table-column
              :label="$t('common.changeTime')"
              prop="time">
            </el-table-column>
          </el-table>
          <a-pagination style="float: right; margin: 16px 0" :current="systemLogPagination.current" :pageSize="systemLogPagination.pageSize" :total="systemLogPagination.total" @change="handlePageChange" />
        </div>
        <div v-show="tabKey !== 'device' && tabKey !== 'system'">
          <a-button type="primary" @click="showUserModal" style="position: absolute; top: 12px; right: 20px;">{{ $t('customer.add') }} {{ param }}</a-button>
          <a-table
            :columns="outColumns"
            :data-source="selectedUserList"
            :loading="outerTableLoading"
            :row-key="record => record.id"
          >
            <template v-slot:requiredCaptcha="text">
              {{ text ? $t('common.yes') : $t('common.no') }}
            </template>
            <template v-slot:maintainSmsEnabled="_, record">
                <a-switch :checked-children="$t('common.yes')" :un-checked-children="$t('common.no')" v-model="record.maintainSmsEnabled" />
            </template>
            <template v-slot:inspectionSmsEnabled="_, record">
              <a-switch :checked-children="$t('common.yes')" :un-checked-children="$t('common.no')" v-model="record.inspectionSmsEnabled" />
            </template>
            <template v-slot:errorSmsEnabled="_, record">
              <a-switch :checked-children="$t('common.yes')" :un-checked-children="$t('common.no')" v-model="record.errorSmsEnabled" />
            </template>
            <template v-slot:icon="text">
              <a-icon :type="text" style="font-size: 20px" />
            </template>
            <template v-slot:enabled="text">
              {{ text ? $t('common.yes') : $t('common.no') }}
            </template>
            <template #operation="text, record, index">
              <a-button type="link" style="padding-left: 0" @click="showAddUserModal(record)">{{ $t('buttons.edit') }}</a-button>
              <a-button type="link" style="padding-left: 0" @click="delUser(index)">{{ $t('buttons.delete') }}</a-button>
            </template>
          </a-table>
          <a-modal class="inner" v-model="userModalVisible" :title="`${$t('buttons.add')}${param}`" :width="1400" @ok="selectUsers" :zIndex="1">
            <a-button style="margin-bottom: 10px" type="primary" :loading="isILoading" @click="visible = true">{{ $t('buttons.add') }}</a-button>
            <a-table
              :loading="isInnerLoading"
              :columns="columns"
              :data-source="userList"
              :pagination="pagination"
              :row-key="record => record.id"
              :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
              @change="handleTableChange"
            >
              <template v-slot:requiredCaptcha="text">
                {{ text ? $t('common.yes') : $t('common.no') }}
              </template>
              <template v-slot:icon="text">
                <a-icon :type="text" style="font-size: 20px" />
              </template>
              <template v-slot:enabled="text">
                {{ text ? $t('common.yes') : $t('common.no') }}
              </template>
            </a-table>
          </a-modal>
          <UserModal :visible="visible" :authorities="authorities" :id="record.id" :closeModl="closeModal" :afterClose="handleAfterClose" :info="record" :mobile="mobile" />
        </div>
        <!-- <template v-if="tabKey === 'device'">
          <a-button @click="showDeviceModal" type="primary" style="position: absolute; top: 12px; right: 20px;">添加设备</a-button>
          <a-modal class="device" v-model="deviceModalVisible" title="添加设备" :width="1600" @ok="selectUsers" :footer="null">
            <a-button style="margin-bottom: 10px" type="primary" @click="showAddDeviceModal">新增</a-button>
            <a-table
              :loading="isDeviceLoading"
              :columns="deviceInnerColumns"
              :data-source="devicesList"
              :pagination="devicePagination"
              :row-key="record => record.id"
              @change="handleDeviceTableChange"
            >
              <template v-slot:operation="_, record">
                <a-popconfirm
                  title="确认要添加吗?"
                  ok-text="确认"
                  cancel-text="取消"
                  @confirm="changeDeviceCustomer(record)"
                >
                  <a :disabled="record.customerId == id" href="javascript:;">添加</a>
                </a-popconfirm>
              </template>
              <template v-slot:icon="text">
                <a-icon :type="text" style="font-size: 20px" />
              </template>
              <template v-slot:enabled="text">
                {{ text ? '是' : '否' }}
              </template>
            </a-table>
          </a-modal>
          <a-table
            :loading="outerTableLoading"
            :columns="deviceColumns"
            :data-source="selectedDeviceList"
            :pagination="outerDevicePagination"
            :row-key="record => record.id"
            @change="handleDeviceOuterTableChange"
          >
            <template v-slot:updatedAt="text, record">
              {{ moment(record.updatedAt).format('YYYY-MM-DD HH:mm') }}
            </template>
            <template v-slot:createdAt="text, record">
              {{ moment(record.createdAt).format('YYYY-MM-DD HH:mm') }}
            </template>
            <template v-slot:operation="_, record">
              <a-button
                type="link"
                style="padding-left: 0"
                @click="gotoDevice(record)"
              >编辑</a-button>
              <a-popconfirm
                title="确认要删除吗?"
                ok-text="确认"
                cancel-text="取消"
                @confirm="removeDevice(record)"
              >
                <a href="javascript:;">删除</a>
              </a-popconfirm>
            </template>
          </a-table>
        </template>
        <template v-else-if="tabKey === 'system'">
          <a-form-model layout="inline" style="margin-bottom: 10px">
            <a-form-model-item label="操作用户">
              <a-input v-model="params.name" />
            </a-form-model-item>
            <a-form-model-item label="修改方式">
              <a-select v-model="params.request" style="width: 70px">
                <a-select-option value="">全部</a-select-option>
                <a-select-option value="POST">新增</a-select-option>
                <a-select-option value="PUT">更新</a-select-option>
              </a-select>
            </a-form-model-item>
            <a-form-model-item label="起始时间">
              <a-date-picker @change="changeStartTime" />
            </a-form-model-item>
            <a-form-model-item label="结束时间">
              <a-date-picker @change="changeEndTime" />
            </a-form-model-item>
            <a-button type="primary" style="float: right" @click="getS">查询</a-button>
          </a-form-model>
          <el-table
            :data="systemLogList"
            style="width: 100%"
            :header-cell-style="{ backgroundColor: '#fafafa' }"
            v-loading="isSystemLogLoading"
            @expand-change="handleExpand"
          >
            <el-table-column type="expand">
              <template slot-scope="props">
                <div style="padding: 0 50px">
                  <a-spin v-show="!props.row.description"></a-spin>
                  <div v-show="props.row.description" class="system_log_description">
                    <h3 style="margin-bottom: 15px">修改详情</h3>
                    <a-row style="margin-bottom: 15px">
                      <a-col :span="7">
                        <p>公司名称：{{ props.row.description.company }}</p>
                        <p>城市：{{ props.row.description.city }}</p>
                        <p>联系方式：{{ props.row.description.mobile }}</p>
                      </a-col>
                      <a-col :span="9">
                        <p>公司地址：{{ props.row.description.address }}</p>
                        <p>区域：{{ props.row.description.area }}</p>
                      </a-col>
                      <a-col :span="8">
                        <p>省份：{{ props.row.description.province }}</p>
                        <p>联络人：{{ props.row.description.contactPerson }}</p>
                      </a-col>
                    </a-row>
                    <a-row>
                      <a-col>
                        <h4>用户：</h4>
                        <p v-for="u in props.row.description.users" :key="u.id">
                          <span>用户名：{{ u.realName }}</span>
                          <span>手机号：{{ u.username }}</span>
                          <span>组织：{{ u.organization }}</span>
                          <template v-if="props.row.description.showEnable">
                            <span>保养短信通知：{{ u.maintainSmsEnabled ? '开启' : '关闭' }}</span>
                            <span>巡检短信通知：{{ u.inspectionSmsEnabled ? '开启' : '关闭' }}</span>
                            <span>故障短信通知：{{ u.errorSmsEnabled ? '开启' : '关闭' }}</span>
                          </template>
                        </p>
                      </a-col>
                    </a-row>
                    <a-row>
                      <a-col>
                        <h4>销售员：</h4>
                        <p v-for="u in props.row.description.salesmen" :key="u.id">
                          <span>用户名：{{ u.realName }}</span>
                          <span>手机号：{{ u.username }}</span>
                          <span>组织：{{ u.organization }}</span>
                          <template v-if="props.row.description.showEnable">
                            <span>保养短信通知：{{ u.maintainSmsEnabled ? '开启' : '关闭' }}</span>
                            <span>巡检短信通知：{{ u.inspectionSmsEnabled ? '开启' : '关闭' }}</span>
                            <span>故障短信通知：{{ u.errorSmsEnabled ? '开启' : '关闭' }}</span>
                          </template>
                        </p>
                      </a-col>
                    </a-row>
                    <a-row>
                      <a-col>
                        <h4>服务员：</h4>
                        <p v-for="u in props.row.description.serviceMans" :key="u.id">
                          <span>用户名：{{ u.realName }}</span>
                          <span>手机号：{{ u.username }}</span>
                          <span>组织：{{ u.organization }}</span>
                          <template v-if="props.row.description.showEnable">
                            <span>保养短信通知：{{ u.maintainSmsEnabled ? '开启' : '关闭' }}</span>
                            <span>巡检短信通知：{{ u.inspectionSmsEnabled ? '开启' : '关闭' }}</span>
                            <span>故障短信通知：{{ u.errorSmsEnabled ? '开启' : '关闭' }}</span>
                          </template>
                        </p>
                      </a-col>
                    </a-row>
                    <a-row>
                      <a-col>
                        <h4>跟进人：</h4>
                        <p v-for="u in props.row.description.followers" :key="u.id">
                          <span>用户名：{{ u.realName }}</span>
                          <span>手机号：{{ u.username }}</span>
                          <span>组织：{{ u.organization }}</span>
                          <template v-if="props.row.description.showEnable">
                            <span>保养短信通知：{{ u.maintainSmsEnabled ? '开启' : '关闭' }}</span>
                            <span>巡检短信通知：{{ u.inspectionSmsEnabled ? '开启' : '关闭' }}</span>
                            <span>故障短信通知：{{ u.errorSmsEnabled ? '开启' : '关闭' }}</span>
                          </template>
                        </p>
                      </a-col>
                    </a-row>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              label="操作用户"
              prop="user.realName">
            </el-table-column>
            <el-table-column
              label="用户号码"
              prop="user.username">
            </el-table-column>
            <el-table-column
              label="用户组织"
              prop="user.organizationName">
            </el-table-column>
            <el-table-column
              label="修改方式"
              prop="request">
            </el-table-column>
            <el-table-column
              label="修改时间"
              prop="time">
            </el-table-column>
          </el-table>
          <a-pagination style="float: right; margin: 16px 0" :current="systemLogPagination.current" :pageSize="systemLogPagination.pageSize" :total="systemLogPagination.total" @change="handlePageChange" />
        </template>
        <template v-else>
          <a-button type="primary" @click="showUserModal" style="position: absolute; top: 12px; right: 20px;">添加{{ param }}</a-button>
          <a-table
            :columns="outColumns"
            :data-source="selectedUserList"
            :loading="outerTableLoading"
            :row-key="record => record.id"
          >
            <template v-slot:requiredCaptcha="text">
              {{ text ? '是' : '否' }}
            </template>
            <template v-slot:maintainSmsEnabled="_, record">
                <a-switch checked-children="是" un-checked-children="否" v-model="record.maintainSmsEnabled" />
            </template>
            <template v-slot:inspectionSmsEnabled="_, record">
              <a-switch checked-children="是" un-checked-children="否" v-model="record.inspectionSmsEnabled" />
            </template>
            <template v-slot:errorSmsEnabled="_, record">
              <a-switch checked-children="是" un-checked-children="否" v-model="record.errorSmsEnabled" />
            </template>
            <template v-slot:icon="text">
              <a-icon :type="text" style="font-size: 20px" />
            </template>
            <template v-slot:enabled="text">
              {{ text ? '是' : '否' }}
            </template>
            <template #operation="text, record, index">
              <a-button type="link" style="padding-left: 0" @click="showAddUserModal(record)">编辑</a-button>
              <a-button type="link" style="padding-left: 0" @click="delUser(index)">删除</a-button>
            </template>
          </a-table>
          <a-modal class="inner" v-model="userModalVisible" :title="`新增${param}`" :width="1400" @ok="selectUsers" :zIndex="1">
            <a-button style="margin-bottom: 10px" type="primary" :loading="isILoading" @click="visible = true">新增</a-button>
            <a-table
              :loading="isInnerLoading"
              :columns="columns"
              :data-source="userList"
              :pagination="pagination"
              :row-key="record => record.id"
              :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
              @change="handleTableChange"
            >
              <template v-slot:requiredCaptcha="text">
                {{ text ? '是' : '否' }}
              </template>
              <template v-slot:icon="text">
                <a-icon :type="text" style="font-size: 20px" />
              </template>
              <template v-slot:enabled="text">
                {{ text ? '是' : '否' }}
              </template>
            </a-table>
          </a-modal>
          <UserModal :visible="visible" :authorities="authorities" :id="record.id" :closeModl="closeModal" :afterClose="handleAfterClose" :info="record" :mobile="mobile" />
        </template> -->
      </a-card>
    </div>
    <transition name="bounce" enter-active-class="animate__animated animate__zoomIn" leave-active-class="animate__animated animate__zoomOut">
      <div v-show="isDeviceModalShow" class="deviceModal">
        <div style="margin: 10px;display: flex;justify-content: space-between;align-items: center;margin-right: 30px">
          <div style="font-size: 20px">{{ $t('customer.addDevice') }}</div>
          <div>
            <a-space>
              <a-button key="submit" type="primary" @click="save">{{ $t('buttons.save') }}</a-button>
              <a-button key="submit" @click="closeAddDeviceModal">{{ $t('buttons.goBack') }}</a-button>
            </a-space>
          </div>
        </div>
        <div style="position: relative;">
          <a-form-model
            style="width: 100%; display: flex; justify-content: space-between; padding-right: 150px; padding-top: 20px"
            v-bind="{labelCol: { span: 8 },wrapperCol: { span: 16 }}"
            :rules="rules"
            :model="deviceForm"
            ref="ruleForm"
          >
            <div style="width: 50%">
              <a-form-model-item :label="$t('common.deviceType')" prop="type">
                <a-select v-model="deviceForm.type" @change="handleTypeChange">
                  <a-select-option v-for="item in deviceTypeList" :key="item.id" :value="item.value">{{ item.text }}</a-select-option>
                </a-select>
              </a-form-model-item>
              <a-form-model-item :label="$t('common.deviceCode')" prop="code">
                <a-input v-model="deviceForm.code" type="text"></a-input>
              </a-form-model-item>
              <a-form-model-item :label="$t('common.deviceName')" prop="name">
                <a-input v-model="deviceForm.name" type="text"></a-input>
              </a-form-model-item>
              <a-form-model-item :label="$t('common.deviceAddress')" prop="deviceAddress">
                <a-input v-model="deviceForm.deviceAddress" type="text"></a-input>
              </a-form-model-item>
              <a-form-model-item :label="$t('common.model')" prop="model">
                <a-input v-model="deviceForm.model" type="text"></a-input>
              </a-form-model-item>
              <a-form-model-item :label="$t('common.customer')" prop="customerId">
                <a-select
                  show-search
                  v-model="deviceForm.customerId"
                  :placeholder="$t('placeholder.searchCustomer')"
                  :default-active-first-option="false"
                  :show-arrow="false"
                  :filter-option="false"
                  :not-found-content="null"
                  @search="handleSearchCustomer"
                  @popupScroll="handlePopupScroll"
                  @blur="handleBlur"
                >
                  <a-select-option v-for="d in customerResultList" :key="d.id">
                    {{ d.company }}
                  </a-select-option>
                </a-select>
              </a-form-model-item>
              <a-form-model-item :label="$t('common.protocolCode')" prop="protocolCode" style="position: relative;">
                <a-select
                  show-search
                  v-model="deviceForm.protocolCode"
                  :placeholder="$t('placeholder.searchProtocolCode')"
                  :default-active-first-option="false"
                  :show-arrow="false"
                  :filter-option="false"
                  :not-found-content="null"
                  @search="handleSearchProtocol"
                  @popupScroll="handleProtocolPopupScroll"
                  @blur="handleBlur"
                  @change="handleChange"
                  option-label-prop="label"
                >
                  <a-select-option :title="d.code + ' - ' + d.name" v-for="d in protocolList" :key="d.code" :value="d.code" :label="d.code">
                    {{ d.code }} - {{ d.name }}
                  </a-select-option>
                </a-select>
              </a-form-model-item>
              <a-form-model-item :label="$t('common.driverType')" prop="driverType">
                <a-select style="width: 100%;" disabled v-model="deviceForm.driverType">
                  <a-select-option v-for="drive in driveTypeList" :key="drive.value">
                    {{ drive.text }}
                  </a-select-option>
                </a-select>
              </a-form-model-item>
              <a-form-model-item :label="$t('common.intervalTime')" prop="intervalTime">
                <a-select style="width: 100%;" v-model="deviceForm.intervalTime" :getPopupContainer="(triggerNode) => triggerNode.parentNode">
                  <a-select-option value="10">
                    10
                  </a-select-option>
                  <a-select-option value="30">
                    30
                  </a-select-option>
                  <a-select-option value="60">
                    60
                  </a-select-option>
                  <a-select-option value="180">
                    180
                  </a-select-option>
                  <a-select-option value="300">
                    300
                  </a-select-option>
                  <a-select-option value="600">
                    600
                  </a-select-option>
                </a-select>
              </a-form-model-item>
              <a-form-model-item :label="$t('common.dtuCode')" prop="dtuCode">
                <a-input v-model="deviceForm.dtuCode" type="text"></a-input>
              </a-form-model-item>
              <a-form-model-item :label="$t('common.brand')">
                <a-input v-model="deviceForm.brand" type="text"></a-input>
              </a-form-model-item>
              <a-form-model-item :label="$t('common.installAddress')">
                <a-input v-model="deviceForm.installAddress" type="text"></a-input>
              </a-form-model-item>
            </div>
            <div style="width: 50%">
              <a-form-model-item :label="$t('common.measurement')" prop="measurement">
                <a-input v-model="deviceForm.measurement" type="text"></a-input>
              </a-form-model-item>
              <a-form-model-item :label="$t('common.initialValue')" prop="initialValue">
                <a-input v-model="deviceForm.initialValue" type="text"></a-input>
              </a-form-model-item>
              <a-form-model-item :label="$t('common.remark')">
                <a-input v-model="deviceForm.remark" type="text"></a-input>
              </a-form-model-item>
              <a-form-model-item :label="$t('common.power')">
                <a-input v-model="deviceForm.power" type="text"></a-input>
              </a-form-model-item>
              <a-form-model-item :label="$t('common.pressure')">
                <a-input v-model="deviceForm.pressure" type="text"></a-input>
              </a-form-model-item>
              <!-- <a-form-model-item :label="$t('common.warrantyPeriod')">
                <a-input v-model="deviceForm.warrantyPeriod" type="text"></a-input>
              </a-form-model-item> -->
              <a-form-model-item :label="$t('common.isStationDevice')">
                <a-switch :checked-children="$t('common.yes')" :un-checked-children="$t('common.no')" v-model="deviceForm.isStationDevice" />
              </a-form-model-item>
            </div>
          </a-form-model>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import draggable from "vuedraggable"
import { getDeviceList, searchDeviceList, deleteDevice, updateDevice, generateDeviceCode } from '@/api/device'
import { getDict } from '@/api/dict'
import { getRegions } from '@/api/auth/ssq'
import {
  searchCustomerList,
  getCustomerListByCompany,
  addCustomer,
  getCustomerById,
  updateCustomer
} from '@/api/customer'
import {
  getOrganizationList,
  searchOrganizationList
} from '@/api/auth/organization'
import {
  getUserList,
  searchUserList,
  addUser,
  updateUser,
  removeUser,
  searchUserByMobile
} from '@/api/auth/user'
import {
  getRoleList,
  searchRoleList
} from '@/api/auth/role'
import {
  findConpany,
  findThisConpany
} from "@/api/crm";
import moment from 'moment'
import { addDevice } from '@/api/device'
import { searchProtocolCode } from '@/api/protocol'
import { getSystemLog } from '@/api/SystemLog'
import { resetPassword } from '@/api/auth/index'
import UserModal from '@/components/common/UserModal.vue'
import chinaCitys from "@/plugins/ChinaCitys.json"

const booleanMap = {
  '是': true,
  '否': false
}

const queryParams = {
  query: [
    {
      field: 'company',
      value: ''
    }
  ],
  filter: [],
  sort: []
}

export default {
  components: {
    VNodes: {
      functional: true,
      render: (h, ctx) => ctx.props.vnodes
    },
    UserModal
  },
  data() {
    return {
      columns: [
        {
          title: () => (<div>{ this.$t('user.columns.name') }<span class="icons unset" style="cursor: pointer;" data-index="0"><a-icon type="caret-up" /><a-icon type="caret-down" /></span><a-input key={ this.tabKey } type="text" data-index="0" /></div>),
          dataIndex: 'realName',
          key: 'realName'
        },
        {
          title: () => (<div>{ this.$t('user.columns.mobile') }<span class="icons unset" style="cursor: pointer;" data-index="1"><a-icon type="caret-up" /><a-icon type="caret-down" /></span><a-input key={ this.tabKey } type="text" class="username" data-index="1" /></div>),
          dataIndex: 'username',
          key: 'username'
        },
        {
          title: () => (<div>{ this.$t('user.columns.organization') }<a-input key={ this.tabKey } type="text" class="username" data-index="2" /></div>),
          dataIndex: 'organization',
          key: 'organization'
        },
        {
          title: () => this.$t('user.columns.requiredCaptcha'),
          dataIndex: 'requiredCaptcha',
          key: 'requiredCaptcha',
          width: 160,
          scopedSlots: {
            customRender: 'requiredCaptcha'
          }
        },
        {
          title: () => this.$t('user.columns.enabled'),
          dataIndex: 'enabled',
          key: 'enabled',
          scopedSlots: {
            customRender: 'enabled'
          },
          width: 120
        },
        {
          title: () => (<div>{ this.$t('common.createdAt') }<span class="icons unset" style="cursor: pointer; right: -52px" data-index="4"><a-icon type="caret-up" /><a-icon type="caret-down" /></span></div>),
          dataIndex: 'createdAt',
          key: 'createdAt',
          width: 180
        },
        {
          title: () => (<div>{ this.$t('common.updatedAt') }<span class="icons DESC" style="cursor: pointer; right: -52px" data-index="5"><a-icon type="caret-up" /><a-icon type="caret-down" /></span></div>),
          dataIndex: 'updatedAt',
          key: 'updatedAt',
          width: 180
        }
      ],
      vuColumns: [
        {
          title: () => this.$t('user.columns.name'),
          dataIndex: 'realName',
          key: 'realName'
        },
        {
          title: () => this.$t('user.columns.mobile'),
          dataIndex: 'username',
          key: 'username'
        },
        {
          title: () => this.$t('user.columns.organization'),
          dataIndex: 'organizationName',
          key: 'organizationName'
        },
        {
          title: () => this.$t('user.columns.requiredCaptcha'),
          dataIndex: 'requiredCaptcha',
          key: 'requiredCaptcha',
          width: 160,
          scopedSlots: {
            customRender: 'requiredCaptcha'
          }
        },
        {
          title: () => this.$t('common.operation'),
          dataIndex: 'operation',
          key: 'operation',
          align: 'left',
          scopedSlots: { customRender: 'operation' }
        }
      ],
      outColumns: [],
      noutColumns: [
        {
          title: () => this.$t('user.columns.name'),
          dataIndex: 'realName',
          key: 'realName'
        },
        {
          title: () => this.$t('user.columns.mobile'),
          dataIndex: 'username',
          key: 'username'
        },
        {
          title: () => this.$t('user.columns.organization'),
          dataIndex: 'organizationName',
          key: 'organizationName'
        },
        {
          title: () => this.$t('user.columns.requiredCaptcha'),
          dataIndex: 'requiredCaptcha',
          key: 'requiredCaptcha',
          width: 160,
          scopedSlots: {
            customRender: 'requiredCaptcha'
          }
        },
        {
          title: () => this.$t('customer.maintainSmsEnabled'),
          dataIndex: 'maintainSmsEnabled',
          key: 'maintainSmsEnabled',
          width: 160,
          scopedSlots: {
            customRender: 'maintainSmsEnabled'
          }
        },
        {
          title: () => this.$t('customer.inspectionSmsEnabled'),
          dataIndex: 'inspectionSmsEnabled',
          key: 'inspectionSmsEnabled',
          width: 160,
          scopedSlots: {
            customRender: 'inspectionSmsEnabled'
          }
        },
        {
          title: () => this.$t('customer.errorSmsEnabled'),
          dataIndex: 'errorSmsEnabled',
          key: 'errorSmsEnabled',
          width: 160,
          scopedSlots: {
            customRender: 'errorSmsEnabled'
          }
        },
        {
          title: () => this.$t('common.operation'),
          dataIndex: 'operation',
          key: 'operation',
          align: 'left',
          scopedSlots: { customRender: 'operation' }
        }
      ],
      userFormRules: {
        realName: [
          {
            required: true,
            message: this.$t('messages.peu'),
            trigger: 'blur'
          }
        ],
        username: [
          {
            required: true,
            message: this.$t('messages.pem'),
            trigger: 'blur'
          },
          {
            message: this.$t('messages.pemp'),
            pattern: /[0-9]{11}/,
            trigger: 'blur'
          }
        ],
        organizationId: [
          {
            required: true,
            message: this.$t('messages.peo')
          }
        ],
        roleId: [
          {
            required: true,
            message: this.$t('messages.per')
          }
        ]
      },
      params: {
        name: '',
        request: '',
        path: '/customer/',
        sort: 'DESC',
        requestParameters: `"id":${this.$route.query.id}`
      },
      isLoading: false,
      outerTableLoading: false,
      labelCol: { span: 4 },
      wrapperCol: { span: 16 },
      isInnerLoading: false,
      isCompanyListShow: false,
      isCompanyLoading: false,
      userModalVisible: false,
      param: this.$t('common.user'),
      userList: [],
      selectedRowKeys: [],
      users: [],
      salesMen: [],
      serviceMen: [],
      followers: [],
      visitUsers: [],
      device: [],
      title: '',
      lKey: '',
      state: 'add',
      tabKey: 'users',
      isILoading: false,
      driveTypeList: [],
      protocolList: [],
      customerResultList: [],
      deviceTypeList: [],
      deviceStatusList: [],
      customerResultList: [],
      timer: null,
      isSelectionShow: false,
      deviceForm: {
        code: '',
        name: '',
        type: '',
        status: null,
        deviceAddress: '',
        model: '',
        brand: '',
        customerId: undefined,
        installAddress: '',
        driverType: '',
        protocolCode: '',
        measurement: '',
        dtuCode: '',
        remark: '',
        isStationDevice: true,
        initialValue: '',
        power: '',
        pressure: '',
        warrantyPeriod: null,
        intervalTime: '',
        tag: null
      },
      systemLogPagination: {
        current: 1,
        pageSize: 10,
        total: 0
      },
      rules: {
        code: [
          {
            required: true,
            message: this.$t('messages.pedc'),
            trigger: 'blur'
          },
          {
            pattern: /^[a-zA-Z\d]+$/,
            message: this.$t('messages.lon'),
            trigger: 'blur'
          }
        ],
        name: [
          {
            required: true,
            message: this.$t('messages.pedn'),
            trigger: 'blur'
          }
        ],
        model: [
          {
            required: true,
            message: this.$t('messages.pedm'),
            trigger: 'blur'
          }
        ],
        deviceAddress: [
          {
            required: true,
            message: this.$t('messages.peda'),
            trigger: 'blur'
          }
          // {
          //   min: 2,
          //   max: 2,
          //   message: '站号地址必须为2位',
          //   trigger: 'blur'
          // },
          // {
          //   validator(rule, value, callback) {
          //     if (value === '16') {
          //       return callback('请输入正确的16进制地址')
          //     }
          //     const reg = new RegExp(/^[0-9a-f]+$/i)
          //     if(reg.test(value)) {
          //       callback()
          //     } else {
          //       callback(reg.test(value))
          //     }
          //   },
          //   message: '请输入正确的16进制地址',
          //   trigger: 'blur'
          // }
        ],
        type: [
          {
            required: true,
            message: this.$t('messages.pedt')
          }
        ],
        // status: [
        //   {
        //     required: true,
        //     message: '请选择设备状态'
        //   }
        // ],
        customerId: [
          {
            required: true,
            message: this.$t('messages.pec')
          }
        ],
        driverType: [
          {
            required: true,
            message: this.$t('messages.pedd')
          }
        ],
        protocolCode: [
          {
            required: true,
            message: this.$t('messages.pedp'),
            trigger: 'blur'
          }
        ],
        dtuCode: [
          {
            required: true,
            message: this.$t('messages.pedtu')
          }
        ]
      },
      protocolCode: '',
      protocolShow: false,
      page: 1,
      protocolPage: 1,
      form: {
        company: undefined,
        address: '',
        mobile: '',
        contactPerson: '',
        country: '',
        province: '',
        city: '',
        area: '',
        lng: null,
        lat: null
      },
      organizationsPage: 1,
      rolePage: 1,
      isDeviceLoading: false,
      deviceInnerColumns: [
        {
          title: () => (<div>{ this.$t('common.deviceCode') }<span class="icons unset" style="cursor: pointer;" data-index="0"><a-icon type="caret-up" /><a-icon type="caret-down" /></span><a-input type="text"  allow-clear data-index="0" /></div>),
          dataIndex: 'code',
          key: 'code'
        },
        {
          title: () => (<div>{ this.$t('common.customerName') }<span class="icons unset" style="cursor: pointer;" data-index="1"><a-icon type="caret-up" /><a-icon type="caret-down" /></span><a-input type="text"  allow-clear data-index="1" /></div>),
          dataIndex: 'customer.company',
          key: 'customer.company'
        },
        {
          title: () => (<div>{ this.$t('common.deviceName') }<span class="icons unset" style="cursor: pointer;" data-index="2"><a-icon type="caret-up" /><a-icon type="caret-down" /></span><a-input type="text" class="username" allow-clear data-index="2" /></div>),
          dataIndex: 'name',
          key: 'name'
        },
        {
          title: () => (<div>{ this.$t('common.model') }<span class="icons unset" style="cursor: pointer;" data-index="3"><a-icon type="caret-up" /><a-icon type="caret-down" /></span><a-input type="text" class="username" allow-clear data-index="3" /></div>),
          dataIndex: 'model',
          key: 'model'
        },
        // {
        //   title: <div>驱动类型<span class="icons unset" style="cursor: pointer;" data-index="3"><a-icon type="caret-up" /><a-icon type="caret-down" /></span><a-input type="text" class="username" allow-clear data-index="3" /></div>,
        //   dataIndex: 'driverType',
        //   key: 'driverType'
        // },
        {
          title: () => (<div>{ this.$t('common.protocolCode') }<span class="icons unset" style="cursor: pointer;" data-index="4"><a-icon type="caret-up" /><a-icon type="caret-down" /></span><a-input type="text" class="username" allow-clear data-index="4" /></div>),
          dataIndex: 'protocolCode',
          key: 'protocolCode',
          scopedSlots: { customRender: 'protocolCode' }
        },
        {
          title: () => (<div>{ this.$t('common.dtuCode') }<span class="icons unset" style="cursor: pointer;" data-index="5"><a-icon type="caret-up" /><a-icon type="caret-down" /></span><a-input type="text" class="username" allow-clear data-index="5" /></div>),
          dataIndex: 'dtuCode',
          key: 'dtuCode',
          scopedSlots: { customRender: 'dtuCode' }
        },
        {
          title: () => (<div>{ this.$t('common.createdAt') }<span class="icons unset" style="cursor: pointer; right: -52px" data-index="6"><a-icon type="caret-up" /><a-icon type="caret-down" /></span></div>),
          dataIndex: 'createdAt',
          key: 'createdAt',
          width: 160,
          scopedSlots: { customRender: 'createdAt' }
        },
        {
          title: () => (<div>{ this.$t('common.updatedAt') }<span class="icons DESC" style="cursor: pointer; right: -52px" data-index="7"><a-icon type="caret-up" /><a-icon type="caret-down" /></span></div>),
          dataIndex: 'updatedAt',
          key: 'updatedAt',
          width: 160,
          scopedSlots: { customRender: 'updatedAt' }
        },
        {
          title: () => this.$t('common.operation'),
          key: 'operation',
          align: 'center',
          scopedSlots: { customRender: 'operation' },
          width: 100
        }
      ],
      deviceColumns: [
        {
          title: () => this.$t('common.deviceCode'),
          dataIndex: 'code',
          key: 'code'
        },
        {
          title: () => this.$t('common.deviceName'),
          dataIndex: 'name',
          key: 'name'
        },
        {
          title: () => this.$t('common.model'),
          dataIndex: 'model',
          key: 'model'
        },
        {
          title: () => this.$t('common.driverType'),
          dataIndex: 'driverType',
          key: 'driverType'
        },
        {
          title: () => this.$t('common.protocolCode'),
          dataIndex: 'protocolCode',
          key: 'protocolCode',
          scopedSlots: { customRender: 'protocolCode' }
        },
        {
          title: () => this.$t('common.dtuCode'),
          dataIndex: 'dtuCode',
          key: 'dtuCode',
          scopedSlots: { customRender: 'dtuCode' }
        },
        {
          title: () => this.$t('common.createdAt'),
          dataIndex: 'createdAt',
          key: 'createdAt',
          width: '9%',
          scopedSlots: { customRender: 'createdAt' }
        },
        {
          title: () => this.$t('common.updatedAt'),
          dataIndex: 'updatedAt',
          key: 'updatedAt',
          width: '9%',
          scopedSlots: { customRender: 'updatedAt' }
        },
        {
          title: () => this.$t('common.operation'),
          key: 'operation',
          align: 'center',
          scopedSlots: { customRender: 'operation' },
          width: 200
        }
      ],
      systemLogC: [
        {
          title: () => this.$t('common.operationUser'),
          dataIndex: 'user.realName',
          key: 'realName'
        },
        {
          title: () => this.$t('common.mobile'),
          dataIndex: 'user.username',
          key: 'username'
        },
        {
          title: () => this.$t('common.organization'),
          dataIndex: 'user.organizationName',
          key: 'organizationName'
        },
        {
          title: () => this.$t('common.request'),
          dataIndex: 'request',
          key: 'request'
        },
        {
          title: () => this.$t('common.changeTime'),
          dataIndex: 'time',
          key: 'time'
        }
      ],
      systemLogList: [],
      deviceModalVisible: false,
      selectedDeviceList: [],
      companyList: [],
      selectedCompanyIndex: -1,
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0
      },
      devicePagination: {
        current: 1,
        pageSize: 10,
        total: 0
      },
      visible: false,
      organizations: [],
      roles: [],
      devicesList: [],
      id: '',
      outerDevicePagination: {
        current: 1,
        pageSize: 10,
        total: 0
      },
      isDeviceModalShow: false,
      errorOptions: {
        company: false
      },
      isOSpin: false,
      tabList: [],
      isSystemLogLoading: false,
      selectedUserList: [],
      mobile: '',
      record: {
        id: 0
      },
      isCountryListShow: false,
      isProvinceListShow: false,
      isCityListShow: false,
      isAreaListShow: false,
      countries: [],
      provinces: [],
      citys: [],
      areas: []
    }
  },
  async created () {
    this.provinces = this.originProvinces = chinaCitys
    this.authorities = this.getAuthorities('/customer')
    this.authorities = this.authorities.concat(this.getAuthorities('/user'))
    if (this.$store.state.customeTabKey) {
      this.tabKey = 'device'
      this.$store.commit('setCustomeTabKey', '')
    }
    await this.getRegionList()
    if (this.$route.query.id) {
      this.lKey = 'editTitle'
      this.outerTableLoading = true
      this.id = this.$route.query.id
      await this.getCustomerInfo(this.$route.query.id)
      if (this.form.province) {
        const p = this.provinces.find(pr => pr.province === this.form.province)
        if (p) {
          this.citys = this.originCitys = p.citys
          if (this.form.city) {
            const c = this.citys.find(ci => ci.city === this.form.city)
            if (c) {
              this.areas = this.originAreas = c.areas
            }
          }
        }
      }
      this.selectedUserList = this[this.tabKey]
    } else {
      const country = localStorage.getItem("country")
      if (country) {
        this.form.country = country
      }
      const c = this.countries.find(c => c.name === this.form.country)
      if (c) {
        this.provinces = this.originProvinces = c.children
      }
      this.lKey = 'addTitle'
    }
    
    this.innerParams = {
      query: [],
      filter: [],
      sort: [
        {
          field: 'updatedAt',
          value: 'DESC'
        }
      ]
    }
    if (this.authorities.find(a => a.code === 'customer:insert' || a.code === 'customer:update')) {
      this.innerParams.filter = []
    } else if (this.authorities.find(a => a.code === 'agent:customer:insert' || a.code === 'agent:customer:update')) {
      this.innerParams.filter = [
        {
          field: 'role',
          value: '客户'
        },
        {
          field: 'role',
          value: '高级客户'
        },
        {
          field: 'role',
          value: '功率客户'
        },
        {
          field: 'role',
          value: '开关机功率客户'
        },
        {
          field: 'mode',
          value: 'or'
        }
      ]
    }
    this.deviceInnerParams = {
      query: [],
      filter: [],
      sort: [
        {
          field: 'updatedAt',
          value: 'DESC'
        }
      ]
    }
    this.translate()
  },
  mounted () {
    const a = this.getAuthorities('/user')
    if (a.find(u => u.code === 'agent:auth:user:query')) {
      return
    }
    this.getAllOrga()
    this.getAllRole()
  },
  computed: {
    paramList() {
      return this.protocolList.filter(item => item.protocolCode.includes(this.protocolCode) || item.protocolName.includes(this.protocolCode))
    },
    lang() {
      return this.$store.state.lang
    }
  },
  watch: {
    lang() {
      this.translate()
    }
  },
  methods: {
    moment,
    async getRegionList() {
      try {
        const { data } = await getRegions()
        this.countries = this.originCountries = data
        this.provinces = this.originProvinces = []
        this.citys = this.originCitys = []
        this.areas = this.originAreas = []
      } catch(e) {
        console.log(e)
        this.countries = this.originCountries = []
        this.provinces = this.originProvinces = []
        this.citys = this.originCitys = []
        this.areas = this.originAreas = []
      }
    },
    translate() {
      const a = []
      this.title = this.$t('customer.' + this.lKey)
      if (this.lKey === 'addTitle') {
        a.push({
          key: 'salesMen',
          tab: this.$t('common.salesMen'),
          sort: 2
        })
        a.push({
          key: 'serviceMen',
          tab: this.$t('common.serviceMen'),
          sort: 3
        })
        for (let i = 0; i < this.authorities.length; i++) {
          if (this.authorities[i].code === 'customer:user:query') {
            a.push({
              key: 'users',
              tab: this.$t('common.user'),
              sort: 1
            })
          }
          if (this.authorities[i].code === 'customer:follower:query') {
            a.push({
              key: 'followers',
              tab: this.$t('common.followers'),
              sort: 4
            })
          }
          if (this.authorities[i].code === "customer:detail:user:visit") {
            a.push({
              key: "visitUsers",
              tab: this.$t('common.authUsers'),
              sort: 5
            })
          }
        }
      }
      if (this.lKey === 'editTitle') {
        for (let i = 0; i < this.authorities.length; i++) {
          if (this.authorities[i].code === 'customer:salesman:query') {
            a.push({
              key: 'salesMen',
              tab: this.$t('common.salesMen'),
              sort: 2
            })
          }
          if (this.authorities[i].code === 'customer:service:query') {
            a.push({
              key: 'serviceMen',
              tab: this.$t('common.serviceMen'),
              sort: 3
            })
          }
          if (this.authorities[i].code === 'customer:user:query') {
            a.push({
              key: 'users',
              tab: this.$t('common.user'),
              sort: 1
            })
          }
          if (this.authorities[i].code === 'customer:follower:query') {
            a.push({
              key: 'followers',
              tab: this.$t('common.followers'),
              sort: 4
            })
          }
          if (this.authorities[i].code === "customer:detail:user:visit") {
            a.push({
              key: "visitUsers",
              tab: this.$t('common.authUsers'),
              sort: 5
            })
          }
          if (this.authorities[i].code === 'system:log:query') {
            a.push({
              key: 'system',
              tab: this.$t('common.record'),
              sort: 7
            })
          }
        }
        a.push({
          key: 'device',
          tab: this.$t('customer.deviceBeingUsed'),
          sort: 6
        })
      }
      this.tabList = a.sort((b, c) => b.sort - c.sort)
      this.tabKey = this.tabList[0].key
      this.onTabChange(this.tabKey)
      this.userFormRules = {
        realName: [
          {
            required: true,
            message: this.$t('messages.peu'),
            trigger: 'blur'
          }
        ],
        username: [
          {
            required: true,
            message: this.$t('messages.pem'),
            trigger: 'blur'
          },
          {
            message: this.$t('messages.pemp'),
            pattern: /[0-9]{11}/,
            trigger: 'blur'
          }
        ],
        organizationId: [
          {
            required: true,
            message: this.$t('messages.peo')
          }
        ],
        roleId: [
          {
            required: true,
            message: this.$t('messages.per')
          }
        ]
      }
      this.rules = {
        code: [
          {
            required: true,
            message: this.$t('messages.pedc'),
            trigger: 'blur'
          },
          {
            pattern: /^[a-zA-Z\d]+$/,
            message: this.$t('messages.lon'),
            trigger: 'blur'
          }
        ],
        name: [
          {
            required: true,
            message: this.$t('messages.pedn'),
            trigger: 'blur'
          }
        ],
        model: [
          {
            required: true,
            message: this.$t('messages.pedm'),
            trigger: 'blur'
          }
        ],
        deviceAddress: [
          {
            required: true,
            message: this.$t('messages.peda'),
            trigger: 'blur'
          }
          // {
          //   min: 2,
          //   max: 2,
          //   message: '站号地址必须为2位',
          //   trigger: 'blur'
          // },
          // {
          //   validator(rule, value, callback) {
          //     if (value === '16') {
          //       return callback('请输入正确的16进制地址')
          //     }
          //     const reg = new RegExp(/^[0-9a-f]+$/i)
          //     if(reg.test(value)) {
          //       callback()
          //     } else {
          //       callback(reg.test(value))
          //     }
          //   },
          //   message: '请输入正确的16进制地址',
          //   trigger: 'blur'
          // }
        ],
        type: [
          {
            required: true,
            message: this.$t('messages.pedt')
          }
        ],
        // status: [
        //   {
        //     required: true,
        //     message: '请选择设备状态'
        //   }
        // ],
        customerId: [
          {
            required: true,
            message: this.$t('messages.pec')
          }
        ],
        driverType: [
          {
            required: true,
            message: this.$t('messages.pedd')
          }
        ],
        protocolCode: [
          {
            required: true,
            message: this.$t('messages.pedp'),
            trigger: 'blur'
          }
        ],
        dtuCode: [
          {
            required: true,
            message: this.$t('messages.pedtu')
          }
        ]
      }
    },
    selectOrganization(value) {
      this.userForm.organizationId = value
    },
    selectRole(value) {
      this.userForm.roleId = value
    },
    changeStartTime(date, dateString) {
      if (date) {
        this.params.startTime = +new Date(dateString)
      } else {
        delete this.params.startTime
      }
    },
    changeEndTime(date, dateString) {
      if (date) {
        this.params.endTime = +new Date(dateString) + 24 * 3600 * 1000 - 1
      } else {
        delete this.params.endTime
      }
    },
    async getCustomerInfo(id) {
      try {
        const { data } = await getCustomerById(id)
        if (data) {
          this.form = data
        }
        this.users = data.users
        this.salesMen = data.salesmen
        this.serviceMen = data.serviceMans
        this.followers = data.followers
        this.visitUsers = data.visitUsers
        this.selectedRowKeys = this.users.map(i => i.id)
        const res = await searchDeviceList(this.outerDevicePagination.current, this.outerDevicePagination.pageSize, {
          query: [],
          filter: [
            {
              field: "customerId",
              value: id
            }
          ],
          sort: []
        })
        this.selectedDeviceList = res.data.records
        this.outerDevicePagination.current = res.data.current
        this.outerDevicePagination.total = res.data.total

      } catch(e) {
        console.log(e)
      } finally {
        this.outerTableLoading = false
      }
    },
    async handleTypeChange(value) {
      if (value === 'LGJ') {
        this.deviceForm.code = ''
        return
      }
      try {
        const { data } = await generateDeviceCode({ deviceType: value })
        this.deviceForm.code = data
      } catch(e) {
        console.log(e)
      }
    },
    delUser(index) {
      this.selectedUserList.splice(index, 1)
      this.selectedRowKeys = this.selectedUserList.map(i => i.id)
    },
    async handleOPopupScroll(e){
      const { scrollHeight, scrollTop, clientHeight } = e.target
      if(scrollHeight - scrollTop === clientHeight){
        this.organizationsPage++
        const { data } = await searchOrganizationList(this.organizationsPage, 10, {
          query: [
            {
              field: 'details.name',
              value: this.o
            }
          ],
          filter: [],
          sort: []
        })
        this.organizations = this.organizations.concat(data.records)
      }
    },
    async handleRPopupScroll(e){
      const { scrollHeight, scrollTop, clientHeight } = e.target
      if(scrollHeight - scrollTop === clientHeight){
        this.rolePage++
        const { data } = await searchRoleList(this.rolePage, 10, {
          query: [
            {
              field: 'details.name',
              value: this.r
            }
          ],
          filter: [],
          sort: []
        })
        this.roles = this.roles.concat(data.records)
      }
    },
    async getAllOrga() {
      let res = await getOrganizationList(1, 1000)
      // this.userForm.organizationId = res.data.records[0].id
      this.organizations = res.data.records.map(r => {
        r['zh-CN'] = r['en-US'] = ''
        r.details.forEach(d => {
          r[d.locale] = d.name
        })
        return r
      })
    },
    async getOrganizationList(e) {
      if (e.key === 'Enter') {
        this.organizations = []
        this.o = e.target.value
        if (this.o?.trim()) {
          this.organizationsPage = 1
          const { data } = await searchOrganizationList(this.organizationsPage, 10, {
            query: [
              {
                field: 'details.name',
                value: e.target.value
              }
            ],
            filter: [],
            sort: []
          })
          this.organizations = data.records.map(r => {
            r['zh-CN'] = r['en-US'] = ''
            r.details.forEach(d => {
              r[d.locale] = d.name
            })
            return r
          })
        } else {
          this.getAllOrga()
        }
      }
    },
    async getAllRole() {
      let res = await getRoleList(1, 1000)
      if (res.data.total > 1000) {
        res = await getRoleList(1, res.data.total) 
      }
      this.roles = res.data.records.map(r => {
        r['zh-CN'] = r['en-US'] = ''
        r.details.forEach(d => {
          r[d.locale] = d.name
        })
        return r
      })
    },
    async getRoleList(e) {
      if (e.key === 'Enter') {
        this.roles = []
        this.r = e.target.value
        if (this.r?.trim()) {
          this.rolePage = 1
          const { data } = await searchRoleList(this.organizationsPage, 10, {
            query: [
              {
                field: 'details.name',
                value: e.target.value
              }
            ],
            filter: [],
            sort: []
          })
          this.roles = data.records.map(r => {
            r['zh-CN'] = r['en-US'] = ''
            r.details.forEach(d => {
              r[d.locale] = d.name
            })
            return r
          })
        } else {
          this.getAllRole()
        }
      }
    },
    async showAddUserModal(r) {
      if (!(r instanceof PointerEvent)) {
        this.isILoading = true
        for (let i in this.userForm) {
          this.userForm[i] = r[i]
        }
        const { data } = await searchUserList(1, 10, {
          query: [],
          filter: [
            {
              field: 'id',
              value: r.id
            }
          ]
        })
        this.record = data.records[0]
        this.mobile = this.record.username
      }
      // await this.getAllOrga()
      // await this.getAllRole()
      this.visible = true
      this.isILoading = false
    },
    async onTabChange(key) {
      this.tabKey = key
      this.selectedUserList = this[this.tabKey]
      switch (key) {
        case 'users':
          this.param = this.$t('common.user')
          if (this.authorities.find(a => a.code === 'customer:insert' || a.code === 'customer:update')) {
            this.innerParams.filter = []
          } else if (this.authorities.find(a => a.code === 'agent:customer:insert' || a.code === 'agent:customer:update')) {
            this.innerParams.filter = [
              {
                field: 'role',
                value: '客户'
              },
              {
                field: 'role',
                value: '高级客户'
              },
              {
                field: 'role',
                value: '功率客户'
              },
              {
                field: 'role',
                value: '开关机功率客户'
              },
              {
                field: 'mode',
                value: 'or'
              }
            ]
          }
          this.outColumns = this.noutColumns
          break;
        case 'salesMen':
          this.param = this.$t('common.salesMen')
          if (this.authorities.find(a => a.code === 'customer:insert' || a.code === 'customer:update')) {
            this.innerParams.filter = [
              {
                field: 'organization',
                value: '客户',
                req: 'ne'
              }
            ]
          } else if (this.authorities.find(a => a.code === 'agent:customer:insert' || a.code === 'agent:customer:update')) {
            this.innerParams.filter = [
              {
                field: "mode",
                value: "and"
              },
              {
                type: "or",
                properties: [
                  {
                    field: 'role',
                    value: '客户'
                  },
                  {
                    field: 'role',
                    value: '高级客户'
                  },
                  {
                    field: 'role',
                    value: '功率客户'
                  },
                  {
                    field: 'role',
                    value: '开关机功率客户'
                  }
                ]
              },
              {
                field: "organization",
                value: "客户",
                req: 'ne'
              }
            ]
          }
          this.outColumns = this.noutColumns
          break;
        case 'serviceMen':
          this.param = this.$t('common.serviceMen')
          if (this.authorities.find(a => a.code === 'customer:insert' || a.code === 'customer:update')) {
            this.innerParams.filter = [
              {
                field: 'organization',
                value: '客户',
                req: 'ne'
              }
            ]
          } else if (this.authorities.find(a => a.code === 'agent:customer:insert' || a.code === 'agent:customer:update')) {
            this.innerParams.filter = [
              {
                field: "mode",
                value: "and"
              },
              {
                type: "or",
                properties: [
                  {
                    field: 'role',
                    value: '客户'
                  },
                  {
                    field: 'role',
                    value: '高级客户'
                  },
                  {
                    field: 'role',
                    value: '功率客户'
                  },
                  {
                    field: 'role',
                    value: '开关机功率客户'
                  }
                ]
              },
              {
                field: "organization",
                value: "客户",
                req: 'ne'
              }
            ]
          }
          this.outColumns = this.noutColumns
          break;
        case 'followers':
          this.param = this.$t('common.followers')
          this.innerParams.filter = []
          this.outColumns = this.noutColumns
          break;
        case 'visitUsers':
          this.param = this.$t('common.authUsers')
          this.innerParams.filter = []
          this.outColumns = this.vuColumns
          break;
        default:
          break;
      }
      if (this.tabKey !== 'system') {
        this.selectedRowKeys = this[this.tabKey].map(i => i.id)
        this.pagination.current = 1
      } else {
        this.getS()
      }
    },
    async getS() {
      this.isSystemLogLoading = true
      try {
        const { data } = await getSystemLog({
          current: this.systemLogPagination.current,
          pageSize: this.systemLogPagination.pageSize,
          ...this.params
        })
        this.systemLogPagination.current = data.current
        this.systemLogPagination.pageSize = data.size
        this.systemLogPagination.total = data.total
        this.systemLogList = data.records.map(r => {
          r.description = false
          r.time = moment(r.time).format('YYYY-MM-DD HH:mm:ss')
          if (r.request === 'POST') {
            r.request = this.$t('buttons.add')
          }
          if (r.request === 'PUT') {
            r.request = this.$t('common.update')
          }
          return r
        })
      } catch(e) {
        console.log(e)
      } finally {
        this.isSystemLogLoading = false
      }
    },
    handlePageChange(page) {
      this.systemLogPagination.current = page
      this.getS()
    },
    async getDescription(row) {
      const d = JSON.parse(row.requestParameters)?.customer || {}
      const u = {}
      d.users = d?.users || []
      d.followers = d?.followers || []
      d.salesmen = d?.salesmen || []
      d.serviceMans = d?.serviceMans || []
      d.visitUsers = d?.visitUsers || []
      d.showEnable = false
      d.users.forEach(uu => {
        if (typeof uu === 'number') {
          u[uu] = {}
        } else {
          d.showEnable = true
          u[uu.id] = uu
        }
      })
      d.followers.forEach(uu => {
        if (typeof uu === 'number') {
          u[uu] = {}
        } else {
          d.showEnable = true
          u[uu.id] = uu
        }
      })
      d.salesmen.forEach(uu => {
        if (typeof uu === 'number') {
          u[uu] = {}
        } else {
          d.showEnable = true
          u[uu.id] = uu
        }
      })
      d.serviceMans.forEach(uu => {
        if (typeof uu === 'number') {
          u[uu] = {}
        } else {
          d.showEnable = true
          u[uu.id] = uu
        }
      })
      d.visitUsers.forEach(uu => {
        if (typeof uu === 'number') {
          u[uu] = {}
        } else {
          d.showEnable = true
          u[uu.id] = uu
        }
      })
      const promises = []
      for (let i in u) {
        promises.push(new Promise(async resolve => {
          try {
            const { data } = await searchUserList(1, 10, {
              query: [],
              filter: [
                {
                  field: 'id',
                  value: +i
                }
              ],
              sort: []
            })
            u[i].id = +i
            u[i].realName = data.records[0].realName
            u[i].username = data.records[0].username
            u[i].organization = data.records[0].organization
            resolve(data.records[0]);
          } catch(e) {
            console.log(e)
            resolve(false)
          }
        }))
      }
      await Promise.all(promises)
      d.users = d.users.map(uu => {
        if (typeof uu === 'number') {
          return u[uu]
        } else {
          return {
            ...uu,
            id: uu.id,
            realName: u[uu.id].realName,
            username: u[uu.id].username,
            organization: u[uu.id].organization
          }
        }
      })
      d.followers = d.followers.map(uu => {
        if (typeof uu === 'number') {
          return u[uu]
        } else {
          return {
            ...uu,
            id: uu.id,
            realName: u[uu.id].realName,
            username: u[uu.id].username,
            organization: u[uu.id].organization
          }
        }
      })
      d.salesmen = d.salesmen.map(uu => {
        if (typeof uu === 'number') {
          return u[uu]
        } else {
          return {
            ...uu,
            id: uu.id,
            realName: u[uu.id].realName,
            username: u[uu.id].username,
            organization: u[uu.id].organization
          }
        }
      })
      d.serviceMans = d.serviceMans.map(uu => {
        if (typeof uu === 'number') {
          return u[uu]
        } else {
          return {
            ...uu,
            id: uu.id,
            realName: u[uu.id].realName,
            username: u[uu.id].username,
            organization: u[uu.id].organization
          }
        }
      })
      return d
    },
    compareTwoRows(showRow, comparationRow) {
      let o, c
      for (let k in showRow) {
        if (Array.isArray(showRow[k])) {
          comparationRow[k] = comparationRow[k] || []
          for (let i = 0; i < showRow[k].length; i++) {
            o = showRow[k][i]
            c = comparationRow[k].find(co => co.id === o.id)
            if (c) {
              for (let k in o) {
                if (o[k] != c[k]) {
                  if (!o[k] && !c[k]) break
                  o[k] = [c[k], o[k]]
                }
              }
            } else {
              o.add = true
            }
          }
          for (let i = 0; i < comparationRow[k].length; i++) {
            o = comparationRow[k][i]
            c = showRow[k].find(s => s.id === o.id)
            if (!c) {
              showRow[k].push({ ...o, minus: true })
            }
          }
        } else {
          if (showRow[k] != comparationRow[k]) {
            showRow[k] = [comparationRow[k], showRow[k]]
          }
        }
      }
    },
    async handleExpand(row) {
      try {
        row.expanded = !row.expanded
        if (row.expanded && !row.description) {
          const index = this.systemLogList.findIndex(s => s.id === row.id)
          const d = await this.getDescription(row)
          let row1
          if (index < this.systemLogList.length - 1) {
            row1 = this.systemLogList[index + 1]
            const description = await this.getDescription(row1)
            this.compareTwoRows(d, description)
            row.description = d
          } else {
            if (this.systemLogPagination.current * this.systemLogPagination.pageSize < this.systemLogPagination.total) {
              if (row.request !== 'POST') {
                const { data } = await getSystemLog({
                  current: this.systemLogPagination.current + 1,
                  pageSize: this.systemLogPagination.pageSize,
                  ...this.params
                })
                row1 = data.records[0]
                row1.time = moment(row1.time).format('YYYY-MM-DD HH:mm:ss')
                if (row1.request === 'POST') {
                  row1.request = this.$t('buttons.add')
                }
                if (row1.request === 'PUT') {
                  row1.request = this.$t('common.update')
                }
                const description = await this.getDescription(row1)
                this.compareTwoRows(d, description)
                row.description = d
              } else {
                row.description = d
              }
            } else {
              row.description = d
            }
          }
        }
      } catch(e) {
        console.log(e)
        row.description = {}
      }
    },
    async getCustomerTypes() {
      try {
        const { data } = await getDict('zh-CN', 'customerType')
        this.customerTypes = data.content
      } catch {}
    },
    handleMouseenter(e) {
      e.target.style.backgroundColor = '#e6f7ff'
    },
    handleMouseleave(e) {
      if (e.target.className === 'selected') {
        e.target.style.backgroundColor = '#e6f7ff'
      } else {
        e.target.style.backgroundColor = '#fff'
      }
    },
    async handleClick(item, i) {
      this.form.company = item.company
      if (item.fcustomerId) {
        this.form.city = item.city
        this.form.province = item.province
        this.form.area = item.provincial
        this.form.address = item.address
        this.form.contactPerson = item.contactPerson
        this.form.mobile = item.mobile
      } else {
        const result = await findThisConpany(this.form.company);
        if (result.code == 0 && result.data) {
          this.companyDetail = result.data;
          this.form.address = this.companyDetail.regLocation;
          this.form.province = this.companyDetail.province;
          this.form.city = this.companyDetail.city;
          this.form.area = this.companyDetail.district;
        } else {
          this.$notify.error({
            title: this.$t('messages.error'),
            message: this.$t('messages.spk')
          });
        }
      }
      this.selectedCompanyIndex = i
    },
    handleCBlur() {
      this.validate('company')
      this.isCompanyListShow = false
      this.companyList = []
    },
    validate(option) {
      this.errorOptions[option] = !this.form[option]?.trim()
      this.$forceUpdate()
      console.log(option, this.errorOptions[option])
      return this.errorOptions[option]
    },
    gotoDevice(r) {
      getDict('zh-CN', 'deviceType').then(({ data }) => {
        this.deviceTypeList = data.content
      })
      getDict('zh-CN', 'driverType').then(({ data }) => {
        this.driveTypeList = data.content
      })
      // console.log(r);
      // this.$store.commit('setCustomeTabKey', 'device')
      // this.$store.commit('setDeviceInfo', r)
      // this.$router.push('/equipment/list/submit')
      for (let i in this.deviceForm) {
        this.deviceForm[i] = r[i]
      }
      this.deviceForm.id = r.id
      this.customerResultList = [this.form]
      this.deviceForm.customerId = +this.id
      this.isDeviceModalShow = true
    },
    closeModal() {
      this.visible = false
    },
    handleAfterClose() {
      this.mobile = ''
      this.record = {
        id: 0
      }
      this.searchUserList()
      this.visible = false
    },
    removeDevice(record) {
      deleteDevice(record.id).then(async ({ message }) => {
        this.$message.success(message)
        this.outerTableLoading = true
        const res = await searchDeviceList(this.outerDevicePagination.current, this.outerDevicePagination.pageSize, {
          query: [],
          filter: [
            {
              field: "customerId",
              value: this.id
            }
          ],
          sort: []
        })
        this.selectedDeviceList = res.data.records
        this.outerDevicePagination.current = res.data.current
        this.outerDevicePagination.total = res.data.total
        this.outerTableLoading = false
      }).catch((e) => {console.log(e);})
    },
    async handleSearchCompany() {
      if (!this.form.company.trim()) {
        return this.$message.warn(this.$t('messages.company_empty'))
      }
      this.isCompanyListShow = true
      this.isCompanyLoading = true
      try {
        const { data } = await getCustomerListByCompany(this.form.company)
        if (data.length) {
          this.companyList = data
        } else if (this.lKey === 'addTitle') {
          const result = await findConpany("1", "20", this.form.company);
          if (result && result.code == 0) {
            this.companyList = result.data.records.map(r => ({
              company: r.name
            }))
          }
        }
      } catch(e) {
        console.log(e)
      } finally {
        this.isCompanyLoading = false
      }
    },
    async handleSava() {
      const a = []
      a.push(this.validate('company'))
      a.push(this.validate('address'))
      a.push(this.validate('province'))
      a.push(this.validate('city'))
      a.push(this.validate('area'))
      if (this.salesMen.length === 0 || this.serviceMen.length === 0) {
        return this.$message.warn(this.$t('messages.saASe_empty'))
      }
      const form = { ...this.form, country: "" }
      // this.form.users = this.users.map(i => i.id)
      // this.form.salesmen = this.salesMen.map(i => i.id)
      // this.form.serviceMans = this.serviceMen.map(i => i.id)
      // this.form.followers = this.followers.map(i => i.id)
      form.users = this.users.map(i => {
        return {
          id: i.id,
          maintainSmsEnabled: !!i.maintainSmsEnabled,
          inspectionSmsEnabled: !!i.inspectionSmsEnabled,
          errorSmsEnabled: !!i.errorSmsEnabled
        }
      })
      form.salesmen = this.salesMen.map(i => {
        return {
          id: i.id,
          maintainSmsEnabled: !!i.maintainSmsEnabled,
          inspectionSmsEnabled: !!i.inspectionSmsEnabled,
          errorSmsEnabled: !!i.errorSmsEnabled
        }
      })
      form.serviceMans = this.serviceMen.map(i => {
        return {
          id: i.id,
          maintainSmsEnabled: !!i.maintainSmsEnabled,
          inspectionSmsEnabled: !!i.inspectionSmsEnabled,
          errorSmsEnabled: !!i.errorSmsEnabled
        }
      })
      form.followers = this.followers.map(i => {
        return {
          id: i.id,
          maintainSmsEnabled: !!i.maintainSmsEnabled,
          inspectionSmsEnabled: !!i.inspectionSmsEnabled,
          errorSmsEnabled: !!i.errorSmsEnabled
        }
      })
      form.visitUsers = this.visitUsers.map(i => {
        return {
          id: i.id
        }
      })
      if (!a.some(v => v)) {
        if (form.id) {
          const { message } = await updateCustomer(form)
          this.$message.success(message)
        } else {
          const { message } = await addCustomer(form)
          this.$message.success(message)
        }
      }
    },
    goBack() {
      this.$store.commit('setCustomerFlag', true)
      this.$router.back()
    },
    async showUserModal(r) {
      this.innerParams.query = []
      this.userModalVisible = true
      this.searchUserList()
      this.$nextTick(() => {
        const ss = document.querySelectorAll('.inner .ant-table-column-title > div span.icons')
        ss.forEach(i => {
          i.addEventListener('click', () => {
            this.returnFirstPage = false
            let c = ''
            switch (i.classList[1]) {
              case 'ASC':
                c = 'DESC'
                break;
              case 'DESC':
                c = 'unset'
                break;
              case 'unset':
                c = 'ASC'
                break;
              default:
                break;
            }
            i.classList.remove(i.classList[1])
            i.classList.add(c)
            const ii = document.querySelectorAll('.inner .ant-table-column-title > div span.icons:not(.unset)')
            const sort = Array.from(ii).map(item => {
              const index = +item.dataset['index']
              return {
                field: this.columns[index].key,
                value: item.classList[1]
              }
            })
            this.innerParams.sort = sort
            this.searchUserList()
          })
        })
        const ips = document.querySelectorAll('.inner .ant-input')
        ips.forEach(ip => {
          ip.value = ''
          ip.addEventListener('keyup', ({ key, target }) => {
            // console.log(key, target.value.trim())
            if (key === 'Enter') {
              target.value = target.value.trim()
              this.returnFirstPage = true
              // target.value.trim() && this.handleSearch()
              this.handleSearch()
            }
          })
          ip.addEventListener('blur', ({ target }) => {
            target.value = target.value.trim()
          })
        })
        this.s = document.querySelector('body')
        this.s.addEventListener('click', this.handleSelect)
      })
    },
    handleSelect(e) {
      if(e.target.parentNode.parentNode === 'ant-select-dropdown-content') {
        this.handleSearch()
      }
    },
    async searchUserList() {
      this.isInnerLoading = true
      if (this.returnFirstPage) {
        this.pagination.current = 1
      }
      try {
        const { data } = await searchUserList(this.pagination.current, this.pagination.pageSize, this.innerParams)
        this.userList = data.records.map(item => {
          item.createdAt = moment(item.createdAt).format('YYYY-MM-DD HH:mm:ss')
          item.updatedAt = moment(item.updatedAt).format('YYYY-MM-DD HH:mm:ss')
          return item
        })
        this.pagination.current = data.current
        this.pagination.total = data.total
      } catch(e) {
        console.log(e)
      } finally {
        this.isInnerLoading = false
      }
    },
    handleSearch() {
      const ss = document.querySelectorAll('.inner .ant-select')
      // this.innerParams.filter = []
      ss.forEach(s => {
        const vDom = s.querySelector('.inner .ant-select-selection-selected-value')
        if (vDom) {
          const index = +s.dataset['index']
          if (index) {
            const ti = this.innerParams.filter.findIndex(f => f.field === this.columns[index].key)
            if (ti > -1) {
              this.innerParams.filter[ti] = {
                field: this.columns[index].key,
                value: booleanMap[vDom.innerHTML]
              }
            } else {
              this.innerParams.filter.push({
                field: this.columns[index].key,
                value: booleanMap[vDom.innerHTML]
              })
            }
          }
        }
      })
      const ips = document.querySelectorAll('.inner .ant-input')
      this.innerParams.query = []
      ips.forEach(ip => {
        if (ip.value.trim()) {
          this.innerParams.query.push({
            field: this.columns[+ip.dataset['index']].key,
            value: ip.value
          })
        }
      })
      this.searchUserList()
    },
    handleTableChange(pagination) {
      this.returnFirstPage = false
      this.pagination = pagination
      this.searchUserList()
    },
    async handleDeviceOuterTableChange(pagination) {
      this.outerDevicePagination = pagination
      const res = await searchDeviceList(this.outerDevicePagination.current, this.outerDevicePagination.pageSize, {
        query: [],
        filter: [
          {
            field: "customerId",
            value: this.$route.query.id
          }
        ],
        sort: []
      })
      this.selectedDeviceList = res.data.records
      this.outerDevicePagination.current = res.data.current
      this.outerDevicePagination.total = res.data.total
    },
    handleDeviceTableChange(pagination) {
      this.returnDeviceFirstPage = false
      this.devicePagination = pagination
      this.searchDeviceList()
    },
    onSelectChange(rows) {
      this.selectedRowKeys = rows
    },
    selectUsers() {
      // this[this.tabKey] = this.selectedRowKeys.map(i => JSON.parse(i))
      // 改
      this.userModalVisible = false
      this.outerTableLoading = true
      console.log(this.selectedRowKeys)
      const promises = []
      const result = [...this.selectedUserList]
      for (let i = 0; i < this.selectedRowKeys.length; i++) {
        promises.push(new Promise(async (resolve, reject) => {
          try {
            const { data } = await searchUserList(1, 10, {
              query: [],
              filter: [
                {
                  field: 'id',
                  value: this.selectedRowKeys[i]
                }
              ],
              sort: []
            })
            const o = this.selectedUserList.find(s => s.id === this.selectedRowKeys[i])
            if (!o) {
              const item = data.records[0]
              result.push({
                id: this.selectedRowKeys[i],
                maintainSmsEnabled: this.tabKey === 'serviceMen' || this.tabKey === 'users',
                inspectionSmsEnabled: this.tabKey === 'serviceMen',
                errorSmsEnabled: this.tabKey === 'serviceMen',
                organizationId: item.organizationId,
                organizationName: item.organization,
                realName: item.realName,
                username: item.username
              })
            }
            resolve()
          } catch(e) {
            reject(e)
          }
        }))
      }
      Promise.all(promises).then(() => {
        this[this.tabKey] = this.selectedUserList = result
      }).catch(e => {
        console.log(e)
      }).finally(() => {
        this.outerTableLoading = false
      })
    },
    async searchDeviceList(callback) {
      if (this.returnDeviceFirstPage) {
        this.devicePagination.current = 1
      }
      try {
        this.isDeviceLoading = true
        const { data } = await searchDeviceList(this.devicePagination.current, this.devicePagination.pageSize, this.deviceInnerParams)
        this.devicesList = data.records.map(item => {
          item.createdAt = moment(item.createdAt).format('YYYY-MM-DD HH:mm:ss')
          item.updatedAt = moment(item.updatedAt).format('YYYY-MM-DD HH:mm:ss')
          return item
        })
        if (callback) {
          this.search = true
          await callback()
          this.devicePagination.current = data.current
          this.devicePagination.total = data.total
        } else {
          this.devicePagination.current = data.current
          this.devicePagination.total = data.total
        }
      } finally {
        this.isDeviceLoading = false
      }
    },
    showDeviceModal() {
      this.deviceModalVisible = true
      this.$nextTick(() => {
        const ss = document.querySelectorAll('.device .ant-table-column-title > div span.icons')
        ss.forEach(i => {
          i.addEventListener('click', () => {
            this.returnDeviceFirstPage = false
            let c = ''
            switch (i.classList[1]) {
              case 'ASC':
                c = 'DESC'
                break;
              case 'DESC':
                c = 'unset'
                break;
              case 'unset':
                c = 'ASC'
                break;
              default:
                break;
            }
            i.classList.remove(i.classList[1])
            i.classList.add(c)
            const ii = document.querySelectorAll('.device .ant-table-column-title > div span.icons:not(.unset)')
            const sort = Array.from(ii).map(item => {
              const index = +item.dataset['index']
              return {
                field: this.deviceInnerColumns[index].key,
                value: item.classList[1]
              }
            })
            this.deviceInnerParams.sort = sort
            this.searchDeviceList()
          })
        })
        const ips = document.querySelectorAll('.device .ant-input')
        ips.forEach(ip => {
          ip.addEventListener('keyup', ({ key, target }) => {
            // console.log(key, target.value.trim())
            if (key === 'Enter') {
              target.value = target.value.trim()
              this.returnDeviceFirstPage = true
              // target.value.trim() && this.handleSearch()
              this.handleSearchDevice()
            }
          })
          ip.addEventListener('blur', ({ target }) => {
            target.value = target.value.trim()
          })
        })
      })
    },
    handleSearchDevice() {
      const ips = document.querySelectorAll('.device .ant-input')
      this.deviceInnerParams.query = []
      ips.forEach(ip => {
        if (ip.value.trim()) {
          this.deviceInnerParams.query.push({
            field: this.deviceInnerColumns[+ip.dataset['index']].key,
            value: +ip.dataset['index'] === 0 ? ip.value.split('-').join('') : ip.value
          })
        }
      })
      this.searchDeviceList()
    },
    changeDeviceCustomer(record) {
      this.isDeviceLoading = true
      const f = {
        brand: record.brand,
        id: record.id,
        code: record.code,
        name: record.name,
        type: record.type,
        status: record.status,
        model: record.model,
        brand: record.brand,
        customerId: +this.$route.query.id,
        installAddress: record.installAddress,
        deviceAddress: record.deviceAddress.length < 2 ? "0" + record.deviceAddress : record.deviceAddress,
        driverType: record.driverType,
        protocolCode: record.protocolCode,
        measurement: record.measurement,
        dtuCode: record.dtuCode,
        remark: record.remark,
        initialValue: record.initialValue,
        intervalTime: record.intervalTime,
        isStationDevice: record.isStationDevice,
        power: record.power,
        pressure: record.pressure,
        warrantyPeriod: null,
        tag: record.device || null
      }
      updateDevice(f).then(({ message }) => {
        this.$message.success(message)
        this.searchDeviceList()
        this.selectedDeviceList.push(record)
      }).catch(() => {
        // this.$message.error("请求失败")
      })
    },
    showAddDeviceModal() {
      getDict('zh-CN', 'deviceType').then(({ data }) => {
        this.deviceTypeList = data.content
      })
      getDict('zh-CN', 'deviceStatus').then(({ data }) => {
        this.deviceStatusList = data.content
      })
      getDict('zh-CN', 'driverType').then(({ data }) => {
        this.driveTypeList = data.content
      })
      this.customerResultList = [this.form]
      this.deviceForm.customerId = +this.id
      this.deviceModalVisible = false
      this.isDeviceModalShow = true
    },
    selectCustomer (value) {
      this.deviceForm.customerId = value.id
      this.deviceForm.companyName = value.companyName
      this.selected = true
    },
    selectProtocol (value) {
      const res = this.protocolList.find(item => item.protocolCode === value)
      this.deviceForm.driverType = res.driverType
    },
    save () {
      // this.deviceForm.initialValue = +this.deviceForm.initialValue
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.deviceForm.deviceAddress = this.deviceForm.deviceAddress.length < 2 ? "0" + this.deviceForm.deviceAddress : this.deviceForm.deviceAddress
          if (this.deviceForm.id) {
            updateDevice(this.deviceForm).then(({ message }) => {
              this.$message.success(message)
            }).catch(({ message }) => {
              this.$message.warn(message)
            })
          } else {
            addDevice(this.deviceForm).then(({ message }) => {
              this.$message.success(message)
            }).catch(({ message }) => {
              this.$message.warn(message)
            })
          }
        }
      })
    },
    /*  */
    debounce (f, delay, ...args) {
      if (this.timer) {
        clearTimeout(this.timer)
      }
      this.timer = setTimeout(() => {
        f(...args)
        this.timer = null
      }, delay)
    },
    async handlePopupScroll(e){
      const { scrollHeight, scrollTop, clientHeight } = e.target
      if(scrollHeight - scrollTop === clientHeight){
        this.page++
        const { data } = await searchCustomerList(this.page, 10, queryParams)
        this.customerResultList = this.customerResultList.concat(data.records)
      }
    },
    async handleProtocolPopupScroll(e){
      const { scrollHeight, scrollTop, clientHeight } = e.target
      if(scrollHeight - scrollTop === clientHeight){
        this.protocolPage++
        const { data } = await searchProtocolCode(this.protocolPage, 10, value, '')
        this.protocolList = this.protocolList.concat(data.records)
      }
    },
    handleSearchCustomer(value) {
      this.debounce(async () => {
        try {
          queryParams.query[0].value = value
          const { data } = await searchCustomerList(this.page, 10, queryParams)
          this.customerResultList = data.records
          this.page = 1
        } catch(e) {
          console.log(e)
        }
      }, 300)
    },
    handleSearchProtocol(value) {
      this.value = value
      this.debounce(async () => {
        try {
          const { data } = await searchProtocolCode(this.protocolPage, 10, value, value)
          this.protocolList = data.records
          this.protocolPage = 1
        } catch(e) {
          console.log(e)
        }
      }, 300)
    },
    async handleProtocolPopupScroll(e){
      const { scrollHeight, scrollTop, clientHeight } = e.target
      if(scrollHeight - scrollTop === clientHeight){
        this.protocolPage++
        const { data } = await searchProtocolCode(this.protocolPage, 10, this.value, this.value)
        this.protocolList = this.protocolList.concat(data.records)
      }
    },
    handleBlur() {
      this.page = 1
      this.protocolPage = 1
      this.protocolList = []
      this.userList = []
      this.isCompanyListShow = false
      this.companyList = []
      this.$forceUpdate()
    },
    handleChange(value) {
      const p = this.protocolList.find(p => p.code === value)
      this.deviceForm.driverType = p.driver
      this.deviceForm.intervalTime = p.intervalTime
    },
    search (e) {
      if (e.target.value.trim() === '') {
        this.isSelectionShow = false
      } else {
        this.debounce(this.searchCustomer, 500, e.target.value)
      }
    },
    handleFocus (e) {
      this.selected = false
      if (e.target.value.trim() === '') {
        this.customerResultList = []
      } else {
        this.isSelectionShow = true
      }
    },
    selecteProtocol(item) {
      this.protocolCode = this.deviceForm.protocolCode = item.protocolCode
      this.deviceForm.driverType = item.driverType
    },
    closeAddDeviceModal() {
      this.isDeviceModalShow = false
      this.getCustomerInfo(this.$route.query.id)
    },
    async resetP() {
      try {
        const { message } = await resetPassword(this.userForm.id)
        this.$message.success(message)
      } catch(e) {
        console.log(e)
      }
    },
    selectCountry(e, i) {
      const item = e.target.parentNode.querySelector('.selected')
      item && (item.style.backgroundColor = '#fff');
      const c = this.countries[i]
      if (c.name !== this.form.country) {
        localStorage.setItem("country", c.name)
        this.provinces = this.originProvinces = c.children
        this.citys = this.originCitys = []
        this.areas = this.originAreas = []
        this.form.province = this.form.city = this.form.area = undefined
        this.form.country = c.name
      }
    },
    selectProvince(e, i) {
      const item = e.target.parentNode.querySelector('.selected')
      item && (item.style.backgroundColor = '#fff');
      const p = this.provinces[i]
      if (p.name !== this.form.province) {
        this.citys = this.originCitys = p.children
        this.areas = this.originAreas = []
        this.form.city = this.form.area = undefined
        this.form.province = p.name
      }
    },
    selectCity(e, i) {
      const item = e.target.parentNode.querySelector('.selected')
      item && (item.style.backgroundColor = '#fff');
      const p = this.citys[i]
      if (p.name !== this.form.city) {
        this.areas = this.originAreas = p.children
        this.form.area = undefined
        this.form.city = p.name
      }
    },
    selectArea(e, i) {
      const item = e.target.parentNode.querySelector('.selected')
      item && (item.style.backgroundColor = '#fff');
      const p = this.areas[i]
      if (p.name !== this.form.area) {
        this.form.area = p.name
      }
    },
    handleCountryBlur() {
      this.isCountryListShow = false
      this.countries = this.originCountries
    },
    handleProvinceBlur() {
      this.isProvinceListShow = false
      this.provinces = this.originProvinces
      this.validate('province')
    },
    handleCityBlur() {
      this.isCityListShow = false
      this.citys = this.originCitys || []
      this.validate('city')
    },
    handleAreaBlur() {
      this.isAreaListShow = false
      this.areas = this.originAreas || []
      this.validate('area')
    },
    searchCountries(e) {
      this.countries = this.originCountries.filter(o => o.name.includes(e.target.value.trim()))
    },
    searchProvinces(e) {
      this.provinces = this.originProvinces.filter(o => o.province.includes(e.target.value.trim()))
    },
    searchCityss(e) {
      this.citys = this.originCitys.filter(o => o.city.includes(e.target.value.trim()))
    },
    searchAreas(e) {
      this.areas = this.originAreas.filter(o => o.area.includes(e.target.value.trim()))
    }
  }
}
</script>

<style lang="less" scoped>
* {
  box-sizing: border-box;
}
li {
  list-style: none;
}
ul {
  margin: 0;
  padding: 0;
}
.customerDetails {
  position: relative;
  height: 100%;
  header {
    width: 100%;
    height: 55px;
    line-height: 55px;
    padding: 0 24px;
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid #ddd;
    h1 {
      font-size: 18px;
      font-weight: 600;
    }
  }
}
.userInfo {
  width: 100%;
  height: auto;
  padding-left: 24px;
  display: flex;
  align-items: center;
  .infoList {
    height: 100%;
    flex: 1;
    display: flex;
    justify-content: space-around;
    margin-left: 30px;
    font-size: 15px;
    padding: 10px;
    .up, .down {
      display: flex;
      flex-direction: column;
      padding-right: 50px;
      white-space: nowrap;
      .input-wrapper {
        display: flex;
        margin: 10px 0;
        .ant-input {
          width: 500px;
        }
        label {
          width: 100px;
          line-height: 32px;
        }
        .disapear::before {
          display: none;
        }
      }
    }
    ul {
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
    }
  }
}
.content {
  width: 100%;
  min-height: calc(100% - 280px);
  height: auto;
  background-color: #f5f4f7;
  padding: 10px;
  .ant-card {
    height: 100%;
  }
  h1 {
    font-size: 18px;
    font-weight: 600;
  }
}
/deep/ .ant-card-body {
  width: 100%;
  height: calc(100% - 55px);
  padding-bottom: 0;
}
.userList {
  width: 100%;
  height: 100%;
  padding: 0 10px;
  display: flex;
  justify-content: space-between;
  position: relative;
  .wrapper {
    width: 19%;
    height: 100%;
    border: 1px solid #ccc;
    overflow: auto;
    padding: 0 20px 10px;
    h2 {
      height: 50px;
      line-height: 50px;
      margin: 0;
      font-size: 18px;
    }
  }
}
.flip-list-move {
  transition: transform 0.5s;
}

.no-move {
  transition: transform 0s;
}

.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}

.list-group {
  min-height: 20px;
  margin-bottom: 0;
  position: relative;
}

.list-group-item {
  cursor: move;
  position: relative;
}

.list-group-item i {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
}
.col-md-3 {
  border: 1px solid #ccc;
}
.spin {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  top: 10px;
}
.inputSelect {
  position: relative;
  .companyList {
    position: absolute;
    background-color: #fff;
    top: calc(100% + 5px);
    right: 0;
    left: 0;
    z-index: 1000;
    border-radius: 5px;
    box-shadow: 0 0 5px rgba(0, 0, 0, .3);
    padding: 3px 0;
    min-height: 30px;
    max-height: 500px;
    overflow: auto;
    .spin {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
    li {
      height: 30px;
      line-height: 30px;
      padding: 0 10px;
      cursor: pointer;
      font-size: 14px;
      color: #777;
      &.selected {
        background-color: #e6f7ff;
      }
    }
  }
}
.ant-table-column-title div {
  position: relative;
}
.ant-table-column-title span {
  position: relative;
}
.ant-table-column-title .anticon-caret-up {
  position: absolute;
  top: -1px;
  right: -18px;
  font-size: 14px;
  color: #ccc;
}
.ant-table-column-title span.ASC .anticon-caret-up {
  color: #1890ff;
}
.ant-table-column-title span.icons {
  position: absolute;
  right: 18px;
}
.ant-table-column-title span.DESC .anticon-caret-down {
  color: #1890ff;
}
.ant-table-column-title .anticon-caret-down {
  position: absolute;
  top: 8px;
  right: -18px;
  font-size: 14px;
  color: #ccc;
}
.deviceModal {
  width: 100%;
  min-height: calc(100% - 55px);
  position: relative;
}
/deep/ .ant-table-thead > tr > th, .ant-table-tbody > tr > td {
  padding: 8px 16px !important;
}
.input-wrapper label {
  margin-right: 10px;
  &::before {
    display: inline-block;
    margin-right: 4px;
    color: #f5222d;
    font-size: 14px;
    font-family: SimSun,sans-serif;
    line-height: 1;
    content: "*";
  }
}
.system_log_description {
  p {
    span {
      margin: 15px;
      &:first-child {
        margin-left: 0;
      }
    }
  }
}
</style>